import { GroupuiGridRow, GroupuiGridCol } from '@sdc-wob-type-3/group-ui-react';
import Footer from '../footer/Footer';
import Header from '../header/Header';

const License = () => {
  return (
    <div id="page">
      <GroupuiGridRow type="fixed">
        <GroupuiGridCol s="12" m="12" l="12" xl="12" xxl="12">
          <Header />
        </GroupuiGridCol>
      </GroupuiGridRow>

      <GroupuiGridRow type="fixed">
        <GroupuiGridCol s="12" m="12" l="12" xl="12" xxl="12">
          <style
            dangerouslySetInnerHTML={{
              __html:
                "p{margin-top:0pt;margin-bottom:1pt;}span.paraDefault{font-family:'Arial';font-size:11.0pt;}span.pseudo{font-family:'Arial';font-size:11.0pt;}span.title1{font-family:'Arial';font-size:11.0pt;font-weight:bold;}span.title2{font-family:'Arial';font-size:16.0pt;font-weight:bold;}span.licTypeName{font-family:'Arial';font-size:12.0pt;font-weight:bold;}span.licText{font-family:'Courier New';font-size:9.0pt;}span.default{font-family:'Arial';font-size:11.0pt;}",
            }}
          />
          <div
            style={{
              width: '595.25pt',
              marginBottom: '28.3pt',
              marginTop: '28.3pt',
              marginLeft: '56.65pt',
              marginRight: '28.3pt',
            }}
          >
            <p
              className="title1"
              style={{ textAlign: 'center', marginTop: '0.0pt', marginBottom: '8.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="title1">3rd Party Open Source Components License Notes</span>
              <br />
              <br />
            </p>
            <p
              className="title2"
              style={{ textAlign: 'center', marginTop: '0.0pt', marginBottom: '8.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="title2">CIS - Contact Information Service 1.0 (CIS_Frontend_Public)</span>
            </p>
            <p
              className="default"
              style={{ textAlign: 'center', marginTop: '0.0pt', marginBottom: '8.0pt', whiteSpace: 'pre-wrap' }}
            >
              <br />
              <br />
              <span className="default">(FOSS Request #VWAG-2808-02)</span>
              <br />
            </p>
            <p
              className="licTypeName"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '8.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licTypeName">Apache-2.0 (Apache License, v2.0)</span>
            </p>
            <table>
              <tbody>
                <tr>
                  <td
                    style={{
                      backgroundColor: '#c5d9f1',
                      borderTop: '0.25px solid',
                      borderBottom: '0.25px solid',
                      borderLeft: '0.25px solid',
                      borderRight: '0.25px solid',
                    }}
                  >
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>Product</span>
                    </p>
                  </td>
                  <td
                    style={{
                      backgroundColor: '#c5d9f1',
                      borderTop: '0.25px solid',
                      borderBottom: '0.25px solid',
                      borderLeft: '0.25px solid',
                      borderRight: '0.25px solid',
                    }}
                  >
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Component
                      </span>
                    </p>
                  </td>
                  <td
                    style={{
                      backgroundColor: '#c5d9f1',
                      borderTop: '0.25px solid',
                      borderBottom: '0.25px solid',
                      borderLeft: '0.25px solid',
                      borderRight: '0.25px solid',
                    }}
                  >
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>Version</span>
                    </p>
                  </td>
                  <td
                    style={{
                      backgroundColor: '#c5d9f1',
                      borderTop: '0.25px solid',
                      borderBottom: '0.25px solid',
                      borderLeft: '0.25px solid',
                      borderRight: '0.25px solid',
                    }}
                  >
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Copyright notice
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Typescript
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        typescript
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>4.6.4</span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'left', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Copyright (C) Microsoft Corporation. All rights reserved
                      </span>
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <br />
              <span className="licText">Apache License</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Version 2.0, January 2004</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">http://www.apache.org/licenses/</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">TERMS AND CONDITIONS FOR USE, REPRODUCTION, AND DISTRIBUTION</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">1. Definitions.</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                "License" shall mean the terms and conditions for use, reproduction, and distribution as defined by
                Sections 1 through 9 of this document.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                "Licensor" shall mean the copyright owner or entity authorized by the copyright owner that is granting
                the License.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                "Legal Entity" shall mean the union of the acting entity and all other entities that control, are
                controlled by, or are under common control with that entity. For the purposes of this definition,
                "control" means (i) the power, direct or indirect, to cause the direction or management of such entity,
                whether by contract or otherwise, or (ii) ownership of fifty percent (50%) or more of the outstanding
                shares, or (iii) beneficial ownership of such entity.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                "You" (or "Your") shall mean an individual or Legal Entity exercising permissions granted by this
                License.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                "Source" form shall mean the preferred form for making modifications, including but not limited to
                software source code, documentation source, and configuration files.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                "Object" form shall mean any form resulting from mechanical transformation or translation of a Source
                form, including but not limited to compiled object code, generated documentation, and conversions to
                other media types.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                "Work" shall mean the work of authorship, whether in Source or Object form, made available under the
                License, as indicated by a copyright notice that is included in or attached to the work (an example is
                provided in the Appendix below).
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                "Derivative Works" shall mean any work, whether in Source or Object form, that is based on (or derived
                from) the Work and for which the editorial revisions, annotations, elaborations, or other modifications
                represent, as a whole, an original work of authorship. For the purposes of this License, Derivative
                Works shall not include works that remain separable from, or merely link (or bind by name) to the
                interfaces of, the Work and Derivative Works thereof.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                "Contribution" shall mean any work of authorship, including the original version of the Work and any
                modifications or additions to that Work or Derivative Works thereof, that is intentionally submitted to
                Licensor for inclusion in the Work by the copyright owner or by an individual or Legal Entity authorized
                to submit on behalf of the copyright owner. For the purposes of this definition, "submitted" means any
                form of electronic, verbal, or written communication sent to the Licensor or its representatives,
                including but not limited to communication on electronic mailing lists, source code control systems, and
                issue tracking systems that are managed by, or on behalf of, the Licensor for the purpose of discussing
                and improving the Work, but excluding communication that is conspicuously marked or otherwise designated
                in writing by the copyright owner as "Not a Contribution."
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                "Contributor" shall mean Licensor and any individual or Legal Entity on behalf of whom a Contribution
                has been received by Licensor and subsequently incorporated within the Work.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                2. Grant of Copyright License. Subject to the terms and conditions of this License, each Contributor
                hereby grants to You a perpetual, worldwide, non-exclusive, no-charge, royalty-free, irrevocable
                copyright license to reproduce, prepare Derivative Works of, publicly display, publicly perform,
                sublicense, and distribute the Work and such Derivative Works in Source or Object form.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                3. Grant of Patent License. Subject to the terms and conditions of this License, each Contributor hereby
                grants to You a perpetual, worldwide, non-exclusive, no-charge, royalty-free, irrevocable (except as
                stated in this section) patent license to make, have made, use, offer to sell, sell, import, and
                otherwise transfer the Work, where such license applies only to those patent claims licensable by such
                Contributor that are necessarily infringed by their Contribution(s) alone or by combination of their
                Contribution(s) with the Work to which such Contribution(s) was submitted. If You institute patent
                litigation against any entity (including a cross-claim or counterclaim in a lawsuit) alleging that the
                Work or a Contribution incorporated within the Work constitutes direct or contributory patent
                infringement, then any patent licenses granted to You under this License for that Work shall terminate
                as of the date such litigation is filed.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                4. Redistribution. You may reproduce and distribute copies of the Work or Derivative Works thereof in
                any medium, with or without modifications, and in Source or Object form, provided that You meet the
                following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                You must give any other recipients of the Work or Derivative Works a copy of this License; and
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                You must cause any modified files to carry prominent notices stating that You changed the files; and
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                You must retain, in the Source form of any Derivative Works that You distribute, all copyright, patent,
                trademark, and attribution notices from the Source form of the Work, excluding those notices that do not
                pertain to any part of the Derivative Works; and
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                If the Work includes a "NOTICE" text file as part of its distribution, then any Derivative Works that
                You distribute must include a readable copy of the attribution notices contained within such NOTICE
                file, excluding those notices that do not pertain to any part of the Derivative Works, in at least one
                of the following places: within a NOTICE text file distributed as part of the Derivative Works; within
                the Source form or documentation, if provided along with the Derivative Works; or, within a display
                generated by the Derivative Works, if and wherever such third-party notices normally appear. The
                contents of the NOTICE file are for informational purposes only and do not modify the License. You may
                add Your own attribution notices within Derivative Works that You distribute, alongside or as an
                addendum to the NOTICE text from the Work, provided that such additional attribution notices cannot be
                construed as modifying the License. You may add Your own copyright statement to Your modifications and
                may provide additional or different license terms and conditions for use, reproduction, or distribution
                of Your modifications, or for any such Derivative Works as a whole, provided Your use, reproduction, and
                distribution of the Work otherwise complies with the conditions stated in this License.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                5. Submission of Contributions. Unless You explicitly state otherwise, any Contribution intentionally
                submitted for inclusion in the Work by You to the Licensor shall be under the terms and conditions of
                this License, without any additional terms or conditions. Notwithstanding the above, nothing herein
                shall supersede or modify the terms of any separate license agreement you may have executed with
                Licensor regarding such Contributions.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                6. Trademarks. This License does not grant permission to use the trade names, trademarks, service marks,
                or product names of the Licensor, except as required for reasonable and customary use in describing the
                origin of the Work and reproducing the content of the NOTICE file.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                7. Disclaimer of Warranty. Unless required by applicable law or agreed to in writing, Licensor provides
                the Work (and each Contributor provides its Contributions) on an "AS IS" BASIS, WITHOUT WARRANTIES OR
                CONDITIONS OF ANY KIND, either express or implied, including, without limitation, any warranties or
                conditions of TITLE, NON-INFRINGEMENT, MERCHANTABILITY, or FITNESS FOR A PARTICULAR PURPOSE. You are
                solely responsible for determining the appropriateness of using or redistributing the Work and assume
                any risks associated with Your exercise of permissions under this License.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                8. Limitation of Liability. In no event and under no legal theory, whether in tort (including
                negligence), contract, or otherwise, unless required by applicable law (such as deliberate and grossly
                negligent acts) or agreed to in writing, shall any Contributor be liable to You for damages, including
                any direct, indirect, special, incidental, or consequential damages of any character arising as a result
                of this License or out of the use or inability to use the Work (including but not limited to damages for
                loss of goodwill, work stoppage, computer failure or malfunction, or any and all other commercial
                damages or losses), even if such Contributor has been advised of the possibility of such damages.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                9. Accepting Warranty or Additional Liability. While redistributing the Work or Derivative Works
                thereof, You may choose to offer, and charge a fee for, acceptance of support, warranty, indemnity, or
                other liability obligations and/or rights consistent with this License. However, in accepting such
                obligations, You may act only on Your own behalf and on Your sole responsibility, not on behalf of any
                other Contributor, and only if You agree to indemnify, defend, and hold each Contributor harmless for
                any liability incurred by, or claims asserted against, such Contributor by reason of your accepting any
                such warranty or additional liability.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">END OF TERMS AND CONDITIONS</span>
              <br />
            </p>
            <p style={{ marginTop: '0.0pt', marginBottom: '8.0pt', whiteSpace: 'pre-wrap' }}></p>
            <p
              className="licTypeName"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '8.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licTypeName">Apache-2.0 (Apache License, v2.0)</span>
            </p>
            <table>
              <tbody>
                <tr>
                  <td
                    style={{
                      backgroundColor: '#c5d9f1',
                      borderTop: '0.25px solid',
                      borderBottom: '0.25px solid',
                      borderLeft: '0.25px solid',
                      borderRight: '0.25px solid',
                    }}
                  >
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>Product</span>
                    </p>
                  </td>
                  <td
                    style={{
                      backgroundColor: '#c5d9f1',
                      borderTop: '0.25px solid',
                      borderBottom: '0.25px solid',
                      borderLeft: '0.25px solid',
                      borderRight: '0.25px solid',
                    }}
                  >
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Component
                      </span>
                    </p>
                  </td>
                  <td
                    style={{
                      backgroundColor: '#c5d9f1',
                      borderTop: '0.25px solid',
                      borderBottom: '0.25px solid',
                      borderLeft: '0.25px solid',
                      borderRight: '0.25px solid',
                    }}
                  >
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>Version</span>
                    </p>
                  </td>
                  <td
                    style={{
                      backgroundColor: '#c5d9f1',
                      borderTop: '0.25px solid',
                      borderBottom: '0.25px solid',
                      borderLeft: '0.25px solid',
                      borderRight: '0.25px solid',
                    }}
                  >
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Copyright notice
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Web Vitals
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>2.1.4</span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'left', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Copyright 2020 Google LLC
                      </span>
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <br />
              <span className="licText">Apache License</span>
              <br />
              <span className="licText">Version 2.0, January 2004</span>
              <br />
              <span className="licText">http://www.apache.org/licenses/</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">TERMS AND CONDITIONS FOR USE, REPRODUCTION, AND DISTRIBUTION</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">1. Definitions.</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                "License" shall mean the terms and conditions for use, reproduction, and distribution as defined by
                Sections 1 through 9 of this document.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                "Licensor" shall mean the copyright owner or entity authorized by the copyright owner that is granting
                the License.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                "Legal Entity" shall mean the union of the acting entity and all other entities that control, are
                controlled by, or are under common control with that entity. For the purposes of this definition,
                "control" means (i) the power, direct or indirect, to cause the direction or management of such entity,
                whether by contract or otherwise, or (ii) ownership of fifty percent (50%) or more of the outstanding
                shares, or (iii) beneficial ownership of such entity.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                "You" (or "Your") shall mean an individual or Legal Entity exercising permissions granted by this
                License.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                "Source" form shall mean the preferred form for making modifications, including but not limited to
                software source code, documentation source, and configuration files.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                "Object" form shall mean any form resulting from mechanical transformation or translation of a Source
                form, including but not limited to compiled object code, generated documentation, and conversions to
                other media types.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                "Work" shall mean the work of authorship, whether in Source or Object form, made available under the
                License, as indicated by a copyright notice that is included in or attached to the work (an example is
                provided in the Appendix below).
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                "Derivative Works" shall mean any work, whether in Source or Object form, that is based on (or derived
                from) the Work and for which the editorial revisions, annotations, elaborations, or other modifications
                represent, as a whole, an original work of authorship. For the purposes of this License, Derivative
                Works shall not include works that remain separable from, or merely link (or bind by name) to the
                interfaces of, the Work and Derivative Works thereof.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                "Contribution" shall mean any work of authorship, including the original version of the Work and any
                modifications or additions to that Work or Derivative Works thereof, that is intentionally submitted to
                Licensor for inclusion in the Work by the copyright owner or by an individual or Legal Entity authorized
                to submit on behalf of the copyright owner. For the purposes of this definition, "submitted" means any
                form of electronic, verbal, or written communication sent to the Licensor or its representatives,
                including but not limited to communication on electronic mailing lists, source code control systems, and
                issue tracking systems that are managed by, or on behalf of, the Licensor for the purpose of discussing
                and improving the Work, but excluding communication that is conspicuously marked or otherwise designated
                in writing by the copyright owner as "Not a Contribution."
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                "Contributor" shall mean Licensor and any individual or Legal Entity on behalf of whom a Contribution
                has been received by Licensor and subsequently incorporated within the Work.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">2. Grant of Copyright License. Subject to the terms and conditions of</span>
              <br />
              <span className="licText">
                this License, each Contributor hereby grants to You a perpetual, worldwide, non-exclusive, no-charge,
                royalty-free, irrevocable copyright license to reproduce, prepare Derivative Works of, publicly display,
                publicly perform, sublicense, and distribute the Work and such Derivative Works in Source or Object
                form.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">3. Grant of Patent License. Subject to the terms and conditions of</span>
              <br />
              <span className="licText">
                this License, each Contributor hereby grants to You a perpetual, worldwide, non-exclusive, no-charge,
                royalty-free, irrevocable (except as stated in this section) patent license to make, have made, use,
                offer to sell, sell, import, and otherwise transfer the Work, where such license applies only to those
                patent claims licensable by such Contributor that are necessarily infringed by their Contribution(s)
                alone or by combination of their Contribution(s) with the Work to which such Contribution(s) was
                submitted. If You institute patent litigation against any entity (including a cross-claim or
                counterclaim in a lawsuit) alleging that the Work or a Contribution incorporated within the Work
                constitutes direct or contributory patent infringement, then any patent licenses granted to You under
                this License for that Work shall terminate as of the date such litigation is filed.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">4. Redistribution. You may reproduce and distribute copies of the</span>
              <br />
              <span className="licText">
                Work or Derivative Works thereof in any medium, with or without modifications, and in Source or Object
                form, provided that You meet the following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">(a) You must give any other recipients of the Work or</span>
              <br />
              <span className="licText">Derivative Works a copy of this License; and</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">(b) You must cause any modified files to carry prominent notices</span>
              <br />
              <span className="licText">stating that You changed the files; and</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">(c) You must retain, in the Source form of any Derivative Works</span>
              <br />
              <span className="licText">
                that You distribute, all copyright, patent, trademark, and attribution notices from the Source form of
                the Work, excluding those notices that do not pertain to any part of the Derivative Works; and
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">(d) If the Work includes a "NOTICE" text file as part of its</span>
              <br />
              <span className="licText">
                distribution, then any Derivative Works that You distribute must include a readable copy of the
                attribution notices contained within such NOTICE file, excluding those notices that do not pertain to
                any part of the Derivative Works, in at least one of the following places: within a NOTICE text file
                distributed as part of the Derivative Works; within the Source form or documentation, if provided along
                with the Derivative Works; or, within a display generated by the Derivative Works, if and wherever such
                third-party notices normally appear. The contents of the NOTICE file are for informational purposes only
                and do not modify the License. You may add Your own attribution notices within Derivative Works that You
                distribute, alongside or as an addendum to the NOTICE text from the Work, provided that such additional
                attribution notices cannot be construed as modifying the License.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                You may add Your own copyright statement to Your modifications and may provide additional or different
                license terms and conditions for use, reproduction, or distribution of Your modifications, or for any
                such Derivative Works as a whole, provided Your use, reproduction, and distribution of the Work
                otherwise complies with the conditions stated in this License.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">5. Submission of Contributions. Unless You explicitly state otherwise,</span>
              <br />
              <span className="licText">
                any Contribution intentionally submitted for inclusion in the Work by You to the Licensor shall be under
                the terms and conditions of this License, without any additional terms or conditions. Notwithstanding
                the above, nothing herein shall supersede or modify the terms of any separate license agreement you may
                have executed with Licensor regarding such Contributions.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">6. Trademarks. This License does not grant permission to use the trade</span>
              <br />
              <span className="licText">
                names, trademarks, service marks, or product names of the Licensor, except as required for reasonable
                and customary use in describing the origin of the Work and reproducing the content of the NOTICE file.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">7. Disclaimer of Warranty. Unless required by applicable law or</span>
              <br />
              <span className="licText">
                agreed to in writing, Licensor provides the Work (and each Contributor provides its Contributions) on an
                "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied, including,
                without limitation, any warranties or conditions of TITLE, NON-INFRINGEMENT, MERCHANTABILITY, or FITNESS
                FOR A PARTICULAR PURPOSE. You are solely responsible for determining the appropriateness of using or
                redistributing the Work and assume any risks associated with Your exercise of permissions under this
                License.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">8. Limitation of Liability. In no event and under no legal theory,</span>
              <br />
              <span className="licText">
                whether in tort (including negligence), contract, or otherwise, unless required by applicable law (such
                as deliberate and grossly negligent acts) or agreed to in writing, shall any Contributor be liable to
                You for damages, including any direct, indirect, special, incidental, or consequential damages of any
                character arising as a result of this License or out of the use or inability to use the Work (including
                but not limited to damages for loss of goodwill, work stoppage, computer failure or malfunction, or any
                and all other commercial damages or losses), even if such Contributor has been advised of the
                possibility of such damages.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">9. Accepting Warranty or Additional Liability. While redistributing</span>
              <br />
              <span className="licText">
                the Work or Derivative Works thereof, You may choose to offer, and charge a fee for, acceptance of
                support, warranty, indemnity, or other liability obligations and/or rights consistent with this License.
                However, in accepting such obligations, You may act only on Your own behalf and on Your sole
                responsibility, not on behalf of any other Contributor, and only if You agree to indemnify, defend, and
                hold each Contributor harmless for any liability incurred by, or claims asserted against, such
                Contributor by reason of your accepting any such warranty or additional liability.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">END OF TERMS AND CONDITIONS</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">APPENDIX: How to apply the Apache License to your work.</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                To apply the Apache License to your work, attach the following boilerplate notice, with the fields
                enclosed by brackets "[]" replaced with your own identifying information. (Don't include the brackets!)
                The text should be enclosed in the appropriate comment syntax for the file format. We also recommend
                that a file or class name and description of purpose be included on the same "printed page" as the
                copyright notice for easier identification within third-party archives.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Copyright 2020 Google LLC</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except in
                compliance with the License. You may obtain a copy of the License at
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">https://www.apache.org/licenses/LICENSE-2.0</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                Unless required by applicable law or agreed to in writing, software distributed under the License is
                distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or
                implied. See the License for the specific language governing permissions and limitations under the
                License.
              </span>
              <br />
            </p>
            <p style={{ marginTop: '0.0pt', marginBottom: '8.0pt', whiteSpace: 'pre-wrap' }}></p>
            <p
              className="licTypeName"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '8.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licTypeName">MIT</span>
            </p>
            <table>
              <tbody>
                <tr>
                  <td
                    style={{
                      backgroundColor: '#c5d9f1',
                      borderTop: '0.25px solid',
                      borderBottom: '0.25px solid',
                      borderLeft: '0.25px solid',
                      borderRight: '0.25px solid',
                    }}
                  >
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>Product</span>
                    </p>
                  </td>
                  <td
                    style={{
                      backgroundColor: '#c5d9f1',
                      borderTop: '0.25px solid',
                      borderBottom: '0.25px solid',
                      borderLeft: '0.25px solid',
                      borderRight: '0.25px solid',
                    }}
                  >
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Component
                      </span>
                    </p>
                  </td>
                  <td
                    style={{
                      backgroundColor: '#c5d9f1',
                      borderTop: '0.25px solid',
                      borderBottom: '0.25px solid',
                      borderLeft: '0.25px solid',
                      borderRight: '0.25px solid',
                    }}
                  >
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>Version</span>
                    </p>
                  </td>
                  <td
                    style={{
                      backgroundColor: '#c5d9f1',
                      borderTop: '0.25px solid',
                      borderBottom: '0.25px solid',
                      borderLeft: '0.25px solid',
                      borderRight: '0.25px solid',
                    }}
                  >
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Copyright notice
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Asynckit
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        asynckit
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>0.4.0</span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'left', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Copyright (C) 2016 Alex Indigo
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>Axios</span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>axios</span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>0.27.2</span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'left', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Copyright (C) 2014-present Matt Zabriskie
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>Babel</span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        babel-runtime
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>7.17.2</span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'left', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Copyright (C) 2014-present Sebastian McKenzie and other contributors
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Flatpickr
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        flatpickr
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>4.6.13</span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'left', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Copyright (C) 2017 Gregory Petrosyan
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Follow Redirects
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        follow-redirects
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>1.14.9</span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'left', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Copyright 2014-present Olivier Lalonde &lt;olalonde@gmail.com&gt;, James Talmage
                        &lt;james@talmage.io&gt;, Ruben Verborgh
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Fsevents
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        fsevents
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>2.3.2</span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'left', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Copyright (C) 2010-2020 by Philipp Dunkel, Ben Noordhuis, Elan Shankar, Paul Miller
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        I1 8next Browser Languagedetector
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        i1-8next-browser-languagedetector
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>6.1.4</span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'left', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Copyright (C) 2022 i18next
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        I1 8next
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        i1-8next
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>21.8.3</span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'left', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Copyright (C) 2022 i18next
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Js Tokens
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        js-tokens
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>4.0.0</span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'left', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Copyright (c) 2014, 2015, 2016, 2017, 2018 Simon Lydell
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Loose Envify
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        loose-envify
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>1.4.0</span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'left', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Copyright (C) 2015 Andres Suarez &lt;zertosh@gmail.com&gt;
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>Mime Db</span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>mime-db</span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>1.51.0</span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'left', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Copyright (C) 2014 Jonathan Ong me@jongleberry.com
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Mime Types
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        mime-types
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>2.1.34</span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'left', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Copyright (C) 2014 Jonathan Ong &lt;me@jongleberry.com&gt;, Copyright (C) 2015 Douglas
                        Christopher Wilson &lt;doug@somethingdoug.com&gt;
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Object Assign
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        object-assign
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>4.1.1</span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'left', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        React Dom
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        react-dom
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>17.0.2</span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'left', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Copyright (c) Facebook, Inc. and its affiliates.
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        React I1 8next
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        react-i1-8next
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>11.16.9</span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'left', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Copyright (C) 2022 i18next
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        React Jwt
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        react-jwt
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>1.1.6</span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'left', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Copyright (C) 2020 Gustavo Velazquez
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>React</span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>react</span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>17.0.2</span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'left', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Copyright (C) Facebook, Inc. and its affiliates
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Regenerator Runtime
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        regenerator-runtime
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>0.13.9</span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'left', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Copyright (c) 2014-present, Facebook, Inc.
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Void Elements
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        void-elements
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>3.1.0</span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'left', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Copyright (c) 2014 hemanth
                      </span>
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <br />
              <span className="licText">The MIT License (MIT)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Copyright (c) 2022 i18next</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                Permission is hereby granted, free of charge, to any person obtaining a copy of this software and
                associated documentation files (the "Software"), to deal in the Software without restriction, including
                without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
                copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the
                following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                The above copyright notice and this permission notice shall be included in all copies or substantial
                portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT
                LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
                WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
                SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
              </span>
              <br />
            </p>
            <p style={{ marginTop: '0.0pt', marginBottom: '8.0pt', whiteSpace: 'pre-wrap' }}></p>
            <p
              className="licTypeName"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '8.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licTypeName">MIT</span>
            </p>
            <table>
              <tbody>
                <tr>
                  <td
                    style={{
                      backgroundColor: '#c5d9f1',
                      borderTop: '0.25px solid',
                      borderBottom: '0.25px solid',
                      borderLeft: '0.25px solid',
                      borderRight: '0.25px solid',
                    }}
                  >
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>Product</span>
                    </p>
                  </td>
                  <td
                    style={{
                      backgroundColor: '#c5d9f1',
                      borderTop: '0.25px solid',
                      borderBottom: '0.25px solid',
                      borderLeft: '0.25px solid',
                      borderRight: '0.25px solid',
                    }}
                  >
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Component
                      </span>
                    </p>
                  </td>
                  <td
                    style={{
                      backgroundColor: '#c5d9f1',
                      borderTop: '0.25px solid',
                      borderBottom: '0.25px solid',
                      borderLeft: '0.25px solid',
                      borderRight: '0.25px solid',
                    }}
                  >
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>Version</span>
                    </p>
                  </td>
                  <td
                    style={{
                      backgroundColor: '#c5d9f1',
                      borderTop: '0.25px solid',
                      borderBottom: '0.25px solid',
                      borderLeft: '0.25px solid',
                      borderRight: '0.25px solid',
                    }}
                  >
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Copyright notice
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Html Parse Stringify
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        html-parse-stringify
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>3.0.1</span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'left', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Authors: @HenrikJoreteg and @Philip_Roberts
                      </span>
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <br />
              <span className="licText">MIT License</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Copyright (c)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                Permission is hereby granted, free of charge, to any person obtaining a copy of this software and
                associated documentation files (the "Software"), to deal in the Software without restriction, including
                without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
                copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the
                following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                The above copyright notice and this permission notice (including the next paragraph) shall be included
                in all copies or substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT
                LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
                WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
                SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
              </span>
              <br />
            </p>
            <p style={{ marginTop: '0.0pt', marginBottom: '8.0pt', whiteSpace: 'pre-wrap' }}></p>
            <p
              className="licTypeName"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '8.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licTypeName">MIT</span>
            </p>
            <table>
              <tbody>
                <tr>
                  <td
                    style={{
                      backgroundColor: '#c5d9f1',
                      borderTop: '0.25px solid',
                      borderBottom: '0.25px solid',
                      borderLeft: '0.25px solid',
                      borderRight: '0.25px solid',
                    }}
                  >
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>Product</span>
                    </p>
                  </td>
                  <td
                    style={{
                      backgroundColor: '#c5d9f1',
                      borderTop: '0.25px solid',
                      borderBottom: '0.25px solid',
                      borderLeft: '0.25px solid',
                      borderRight: '0.25px solid',
                    }}
                  >
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Component
                      </span>
                    </p>
                  </td>
                  <td
                    style={{
                      backgroundColor: '#c5d9f1',
                      borderTop: '0.25px solid',
                      borderBottom: '0.25px solid',
                      borderLeft: '0.25px solid',
                      borderRight: '0.25px solid',
                    }}
                  >
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>Version</span>
                    </p>
                  </td>
                  <td
                    style={{
                      backgroundColor: '#c5d9f1',
                      borderTop: '0.25px solid',
                      borderBottom: '0.25px solid',
                      borderLeft: '0.25px solid',
                      borderRight: '0.25px solid',
                    }}
                  >
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Copyright notice
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>Stencil</span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        stencil-core
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>2.15.2</span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'left', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Copyright (C) 2019-present Drifty Co.
                      </span>
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <br />
              <span className="licText">The MIT License (MIT)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Copyright (c) 2019-present Drifty Co.</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                Permission is hereby granted, free of charge, to any person obtaining a copy of this software and
                associated documentation files (the "Software"), to deal in the Software without restriction, including
                without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
                copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the
                following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                The above copyright notice and this permission notice shall be included in all copies or substantial
                portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT
                LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
                WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
                SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                ----------------------------------------- Third-party components, software, and/or libraries
                (collectively, "components") are included under the licenses specified by their authors. For information
                about these third-party licenses, refer to the separate legal notices governing such components at
                NOTICE file at the top level of the package.
              </span>
              <br />
            </p>
            <p style={{ marginTop: '0.0pt', marginBottom: '8.0pt', whiteSpace: 'pre-wrap' }}>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <br />
              <span className="licText">Additional information from NOTICE file:</span>
              <br />
            </p>
            <p style={{ marginTop: '0.0pt', marginBottom: '8.0pt', whiteSpace: 'pre-wrap' }}>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <br />
              <span className="licText"># Licenses of Bundled Dependencies</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">The published Stencil distribution contains the following licenses:</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                Apache-2.0 BSD-2-Clause BSD-3-Clause CC-BY-4.0 ISC MIT MIT OR GPL-2.0-or-later
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                The following distributions have been modified to be bundled within this distribution:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `@rollup/plugin-commonjs`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: Rich Harris &lt;richard.a.harris@gmail.com&gt;</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                Homepage: https://github.com/rollup/plugins/tree/master/packages/commonjs/#readme
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; The MIT License (MIT)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Copyright (c) 2019 RollupJS Plugin Contributors
                (https://github.com/rollup/plugins/graphs/contributors)
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a copy &gt; of this software
                and associated documentation files (the "Software"), to deal &gt; in the Software without restriction,
                including without limitation the rights &gt; to use, copy, modify, merge, publish, distribute,
                sublicense, and/or sell &gt; copies of the Software, and to permit persons to whom the Software is &gt;
                furnished to do so, subject to the following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in &gt; all copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR &gt; IMPLIED, INCLUDING
                BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, &gt; FITNESS FOR A PARTICULAR PURPOSE AND
                NONINFRINGEMENT. IN NO EVENT SHALL THE &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                DAMAGES OR OTHER &gt; LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, &gt;
                OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN &gt; THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `@rollup/plugin-json`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: rollup</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                Homepage: https://github.com/rollup/plugins/tree/master/packages/json#readme
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; The MIT License (MIT)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Copyright (c) 2019 RollupJS Plugin Contributors
                (https://github.com/rollup/plugins/graphs/contributors)
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a copy &gt; of this software
                and associated documentation files (the "Software"), to deal &gt; in the Software without restriction,
                including without limitation the rights &gt; to use, copy, modify, merge, publish, distribute,
                sublicense, and/or sell &gt; copies of the Software, and to permit persons to whom the Software is &gt;
                furnished to do so, subject to the following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in &gt; all copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR &gt; IMPLIED, INCLUDING
                BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, &gt; FITNESS FOR A PARTICULAR PURPOSE AND
                NONINFRINGEMENT. IN NO EVENT SHALL THE &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                DAMAGES OR OTHER &gt; LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, &gt;
                OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN &gt; THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `@rollup/plugin-node-resolve`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: Rich Harris &lt;richard.a.harris@gmail.com&gt;</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                Homepage: https://github.com/rollup/plugins/tree/master/packages/node-resolve/#readme
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; The MIT License (MIT)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Copyright (c) 2019 RollupJS Plugin Contributors
                (https://github.com/rollup/plugins/graphs/contributors)
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a copy &gt; of this software
                and associated documentation files (the "Software"), to deal &gt; in the Software without restriction,
                including without limitation the rights &gt; to use, copy, modify, merge, publish, distribute,
                sublicense, and/or sell &gt; copies of the Software, and to permit persons to whom the Software is &gt;
                furnished to do so, subject to the following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in &gt; all copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR &gt; IMPLIED, INCLUDING
                BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, &gt; FITNESS FOR A PARTICULAR PURPOSE AND
                NONINFRINGEMENT. IN NO EVENT SHALL THE &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                DAMAGES OR OTHER &gt; LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, &gt;
                OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN &gt; THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `@rollup/pluginutils`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: Rich Harris &lt;richard.a.harris@gmail.com&gt;</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                Homepage: https://github.com/rollup/plugins/tree/master/packages/pluginutils#readme
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; The MIT License (MIT)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Copyright (c) 2019 RollupJS Plugin Contributors
                (https://github.com/rollup/plugins/graphs/contributors)
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a copy &gt; of this software
                and associated documentation files (the "Software"), to deal &gt; in the Software without restriction,
                including without limitation the rights &gt; to use, copy, modify, merge, publish, distribute,
                sublicense, and/or sell &gt; copies of the Software, and to permit persons to whom the Software is &gt;
                furnished to do so, subject to the following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in &gt; all copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR &gt; IMPLIED, INCLUDING
                BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, &gt; FITNESS FOR A PARTICULAR PURPOSE AND
                NONINFRINGEMENT. IN NO EVENT SHALL THE &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                DAMAGES OR OTHER &gt; LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, &gt;
                OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN &gt; THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `@yarnpkg/lockfile`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: BSD-2-Clause</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `ansi-colors`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: Brian Woodward (https://github.com/doowb)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                Contributors: Brian Woodward (https://twitter.com/doowb), Jason Schilling (https://sourecode.de), Jon
                Schlinkert (http://twitter.com/jonschlinkert), Jordan (https://github.com/Silic0nS0ldier)
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Homepage: https://github.com/doowb/ansi-colors</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; The MIT License (MIT)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Copyright (c) 2015-present, Brian Woodward.</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a copy &gt; of this software
                and associated documentation files (the "Software"), to deal &gt; in the Software without restriction,
                including without limitation the rights &gt; to use, copy, modify, merge, publish, distribute,
                sublicense, and/or sell &gt; copies of the Software, and to permit persons to whom the Software is &gt;
                furnished to do so, subject to the following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in &gt; all copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR &gt; IMPLIED, INCLUDING
                BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, &gt; FITNESS FOR A PARTICULAR PURPOSE AND
                NONINFRINGEMENT. IN NO EVENT SHALL THE &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                DAMAGES OR OTHER &gt; LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, &gt;
                OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN &gt; THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `autoprefixer`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: Andrey Sitnik &lt;andrey@sitnik.ru&gt;</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; The MIT License (MIT)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Copyright 2013 Andrey Sitnik &lt;andrey@sitnik.ru&gt;</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a copy of &gt; this software
                and associated documentation files (the "Software"), to deal in &gt; the Software without restriction,
                including without limitation the rights to &gt; use, copy, modify, merge, publish, distribute,
                sublicense, and/or sell copies of &gt; the Software, and to permit persons to whom the Software is
                furnished to do so, &gt; subject to the following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in all &gt; copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR &gt; IMPLIED, INCLUDING
                BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS &gt; FOR A PARTICULAR PURPOSE AND
                NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR &gt; COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                DAMAGES OR OTHER LIABILITY, WHETHER &gt; IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT
                OF OR IN &gt; CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `balanced-match`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: [Julian Gruber](http://juliangruber.com)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Homepage: https://github.com/juliangruber/balanced-match</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; (MIT)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Copyright (c) 2013 Julian Gruber &amp;lt;julian@juliangruber.com&amp;gt;
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a copy of &gt; this software
                and associated documentation files (the "Software"), to deal in &gt; the Software without restriction,
                including without limitation the rights to &gt; use, copy, modify, merge, publish, distribute,
                sublicense, and/or sell copies &gt; of the Software, and to permit persons to whom the Software is
                furnished to do &gt; so, subject to the following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in all &gt; copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR &gt; IMPLIED, INCLUDING
                BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, &gt; FITNESS FOR A PARTICULAR PURPOSE AND
                NONINFRINGEMENT. IN NO EVENT SHALL THE &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                DAMAGES OR OTHER &gt; LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, &gt;
                OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE &gt; SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `brace-expansion`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: [Julian Gruber](http://juliangruber.com)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Homepage: https://github.com/juliangruber/brace-expansion</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; MIT License</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Copyright (c) 2013 Julian Gruber &lt;julian@juliangruber.com&gt;</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a copy &gt; of this software
                and associated documentation files (the "Software"), to deal &gt; in the Software without restriction,
                including without limitation the rights &gt; to use, copy, modify, merge, publish, distribute,
                sublicense, and/or sell &gt; copies of the Software, and to permit persons to whom the Software is &gt;
                furnished to do so, subject to the following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in all &gt; copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR &gt; IMPLIED, INCLUDING
                BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, &gt; FITNESS FOR A PARTICULAR PURPOSE AND
                NONINFRINGEMENT. IN NO EVENT SHALL THE &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                DAMAGES OR OTHER &gt; LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, &gt;
                OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE &gt; SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `browserslist`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: Andrey Sitnik &lt;andrey@sitnik.ru&gt;</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; The MIT License (MIT)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Copyright 2014 Andrey Sitnik &lt;andrey@sitnik.ru&gt; and other contributors
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a copy of &gt; this software
                and associated documentation files (the "Software"), to deal in &gt; the Software without restriction,
                including without limitation the rights to &gt; use, copy, modify, merge, publish, distribute,
                sublicense, and/or sell copies of &gt; the Software, and to permit persons to whom the Software is
                furnished to do so, &gt; subject to the following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in all &gt; copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR &gt; IMPLIED, INCLUDING
                BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS &gt; FOR A PARTICULAR PURPOSE AND
                NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR &gt; COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                DAMAGES OR OTHER LIABILITY, WHETHER &gt; IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT
                OF OR IN &gt; CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `buffer-from`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; MIT License</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Copyright (c) 2016, 2018 Linus Unnebäck</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a copy &gt; of this software
                and associated documentation files (the "Software"), to deal &gt; in the Software without restriction,
                including without limitation the rights &gt; to use, copy, modify, merge, publish, distribute,
                sublicense, and/or sell &gt; copies of the Software, and to permit persons to whom the Software is &gt;
                furnished to do so, subject to the following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in all &gt; copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR &gt; IMPLIED, INCLUDING
                BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, &gt; FITNESS FOR A PARTICULAR PURPOSE AND
                NONINFRINGEMENT. IN NO EVENT SHALL THE &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                DAMAGES OR OTHER &gt; LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, &gt;
                OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE &gt; SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `builtin-modules`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: [Sindre Sorhus](https://sindresorhus.com)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; MIT License</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (https://sindresorhus.com)
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a copy of this software and
                associated documentation files (the "Software"), to deal in the Software without restriction, including
                without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
                copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the
                following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in all copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
                NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
                IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
                WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
                SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `caniuse-lite`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: CC-BY-4.0</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: [Ben Briggs](http://beneb.info)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Attribution 4.0 International</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; =======================================================================
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Creative Commons Corporation ("Creative Commons") is not a law firm and &gt; does not provide legal
                services or legal advice. Distribution of &gt; Creative Commons public licenses does not create a
                lawyer-client or &gt; other relationship. Creative Commons makes its licenses and related &gt;
                information available on an "as-is" basis. Creative Commons gives no &gt; warranties regarding its
                licenses, any material licensed under their &gt; terms and conditions, or any related information.
                Creative Commons &gt; disclaims all liability for damages resulting from their use to the &gt; fullest
                extent possible.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Using Creative Commons Public Licenses</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Creative Commons public licenses provide a standard set of terms and &gt; conditions that creators
                and other rights holders may use to share &gt; original works of authorship and other material subject
                to copyright &gt; and certain other rights specified in the public license below. The &gt; following
                considerations are for informational purposes only, are not &gt; exhaustive, and do not form part of our
                licenses.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Considerations for licensors: Our public licenses are &gt; intended for use by those authorized to
                give the public &gt; permission to use material in ways otherwise restricted by &gt; copyright and
                certain other rights. Our licenses are &gt; irrevocable. Licensors should read and understand the terms
                &gt; and conditions of the license they choose before applying it. &gt; Licensors should also secure all
                rights necessary before &gt; applying our licenses so that the public can reuse the &gt; material as
                expected. Licensors should clearly mark any &gt; material not subject to the license. This includes
                other CC- &gt; licensed material, or material used under an exception or &gt; limitation to copyright.
                More considerations for licensors: &gt; wiki.creativecommons.org/Considerations_for_licensors
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Considerations for the public: By using one of our public &gt; licenses, a licensor grants the
                public permission to use the &gt; licensed material under specified terms and conditions. If &gt; the
                licensor's permission is not necessary for any reason--for &gt; example, because of any applicable
                exception or limitation to &gt; copyright--then that use is not regulated by the license. Our &gt;
                licenses grant only permissions under copyright and certain &gt; other rights that a licensor has
                authority to grant. Use of &gt; the licensed material may still be restricted for other &gt; reasons,
                including because others have copyright or other &gt; rights in the material. A licensor may make
                special requests, &gt; such as asking that all changes be marked or described. &gt; Although not
                required by our licenses, you are encouraged to &gt; respect those requests where reasonable.
                More_considerations &gt; for the public: &gt; wiki.creativecommons.org/Considerations_for_licensees
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; =======================================================================
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Creative Commons Attribution 4.0 International Public License</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; By exercising the Licensed Rights (defined below), You accept and agree &gt; to be bound by the
                terms and conditions of this Creative Commons &gt; Attribution 4.0 International Public License ("Public
                License"). To the &gt; extent this Public License may be interpreted as a contract, You are &gt; granted
                the Licensed Rights in consideration of Your acceptance of &gt; these terms and conditions, and the
                Licensor grants You such rights in &gt; consideration of benefits the Licensor receives from making the
                &gt; Licensed Material available under these terms and conditions.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Section 1 -- Definitions.</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; a. Adapted Material means material subject to Copyright and Similar &gt; Rights that is derived
                from or based upon the Licensed Material &gt; and in which the Licensed Material is translated, altered,
                &gt; arranged, transformed, or otherwise modified in a manner requiring &gt; permission under the
                Copyright and Similar Rights held by the &gt; Licensor. For purposes of this Public License, where the
                Licensed &gt; Material is a musical work, performance, or sound recording, &gt; Adapted Material is
                always produced where the Licensed Material is &gt; synched in timed relation with a moving image.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; b. Adapter's License means the license You apply to Your Copyright &gt; and Similar Rights in Your
                contributions to Adapted Material in &gt; accordance with the terms and conditions of this Public
                License.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; c. Copyright and Similar Rights means copyright and/or similar rights &gt; closely related to
                copyright including, without limitation, &gt; performance, broadcast, sound recording, and Sui Generis
                Database &gt; Rights, without regard to how the rights are labeled or &gt; categorized. For purposes of
                this Public License, the rights &gt; specified in Section 2(b)(1)-(2) are not Copyright and Similar &gt;
                Rights.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; d. Effective Technological Measures means those measures that, in the &gt; absence of proper
                authority, may not be circumvented under laws &gt; fulfilling obligations under Article 11 of the WIPO
                Copyright &gt; Treaty adopted on December 20, 1996, and/or similar international &gt; agreements.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; e. Exceptions and Limitations means fair use, fair dealing, and/or &gt; any other exception or
                limitation to Copyright and Similar Rights &gt; that applies to Your use of the Licensed Material.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; f. Licensed Material means the artistic or literary work, database, &gt; or other material to which
                the Licensor applied this Public &gt; License.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; g. Licensed Rights means the rights granted to You subject to the &gt; terms and conditions of this
                Public License, which are limited to &gt; all Copyright and Similar Rights that apply to Your use of the
                &gt; Licensed Material and that the Licensor has authority to license.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; h. Licensor means the individual(s) or entity(ies) granting rights &gt; under this Public License.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; i. Share means to provide material to the public by any means or &gt; process that requires
                permission under the Licensed Rights, such &gt; as reproduction, public display, public performance,
                distribution, &gt; dissemination, communication, or importation, and to make material &gt; available to
                the public including in ways that members of the &gt; public may access the material from a place and at
                a time &gt; individually chosen by them.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; j. Sui Generis Database Rights means rights other than copyright &gt; resulting from Directive
                96/9/EC of the European Parliament and of &gt; the Council of 11 March 1996 on the legal protection of
                databases, &gt; as amended and/or succeeded, as well as other essentially &gt; equivalent rights
                anywhere in the world.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; k. You means the individual or entity exercising the Licensed Rights &gt; under this Public
                License. Your has a corresponding meaning.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Section 2 -- Scope.</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; a. License grant.</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; 1. Subject to the terms and conditions of this Public License, &gt; the Licensor hereby grants You
                a worldwide, royalty-free, &gt; non-sublicensable, non-exclusive, irrevocable license to &gt; exercise
                the Licensed Rights in the Licensed Material to:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; a. reproduce and Share the Licensed Material, in whole or &gt; in part; and
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; b. produce, reproduce, and Share Adapted Material.</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; 2. Exceptions and Limitations. For the avoidance of doubt, where &gt; Exceptions and Limitations
                apply to Your use, this Public &gt; License does not apply, and You do not need to comply with &gt; its
                terms and conditions.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; 3. Term. The term of this Public License is specified in Section &gt; 6(a).
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; 4. Media and formats; technical modifications allowed. The &gt; Licensor authorizes You to exercise
                the Licensed Rights in &gt; all media and formats whether now known or hereafter created, &gt; and to
                make technical modifications necessary to do so. The &gt; Licensor waives and/or agrees not to assert
                any right or &gt; authority to forbid You from making technical modifications &gt; necessary to exercise
                the Licensed Rights, including &gt; technical modifications necessary to circumvent Effective &gt;
                Technological Measures. For purposes of this Public License, &gt; simply making modifications authorized
                by this Section 2(a) &gt; (4) never produces Adapted Material.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; 5. Downstream recipients.</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; a. Offer from the Licensor -- Licensed Material. Every &gt; recipient of the Licensed Material
                automatically &gt; receives an offer from the Licensor to exercise the &gt; Licensed Rights under the
                terms and conditions of this &gt; Public License.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; b. No downstream restrictions. You may not offer or impose &gt; any additional or different terms
                or conditions on, or &gt; apply any Effective Technological Measures to, the &gt; Licensed Material if
                doing so restricts exercise of the &gt; Licensed Rights by any recipient of the Licensed &gt; Material.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; 6. No endorsement. Nothing in this Public License constitutes or &gt; may be construed as
                permission to assert or imply that You &gt; are, or that Your use of the Licensed Material is, connected
                &gt; with, or sponsored, endorsed, or granted official status by, &gt; the Licensor or others designated
                to receive attribution as &gt; provided in Section 3(a)(1)(A)(i).
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; b. Other rights.</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; 1. Moral rights, such as the right of integrity, are not &gt; licensed under this Public License,
                nor are publicity, &gt; privacy, and/or other similar personality rights; however, to &gt; the extent
                possible, the Licensor waives and/or agrees not to &gt; assert any such rights held by the Licensor to
                the limited &gt; extent necessary to allow You to exercise the Licensed &gt; Rights, but not otherwise.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; 2. Patent and trademark rights are not licensed under this &gt; Public License.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; 3. To the extent possible, the Licensor waives any right to &gt; collect royalties from You for the
                exercise of the Licensed &gt; Rights, whether directly or through a collecting society &gt; under any
                voluntary or waivable statutory or compulsory &gt; licensing scheme. In all other cases the Licensor
                expressly &gt; reserves any right to collect such royalties.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Section 3 -- License Conditions.</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Your exercise of the Licensed Rights is expressly made subject to the &gt; following conditions.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; a. Attribution.</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; 1. If You Share the Licensed Material (including in modified &gt; form), You must:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; a. retain the following if it is supplied by the Licensor &gt; with the Licensed Material:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; i. identification of the creator(s) of the Licensed &gt; Material and any others designated to
                receive &gt; attribution, in any reasonable manner requested by &gt; the Licensor (including by
                pseudonym if &gt; designated);
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; ii. a copyright notice;</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; iii. a notice that refers to this Public License;</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; iv. a notice that refers to the disclaimer of &gt; warranties;</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; v. a URI or hyperlink to the Licensed Material to the &gt; extent reasonably practicable;
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; b. indicate if You modified the Licensed Material and &gt; retain an indication of any previous
                modifications; and
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; c. indicate the Licensed Material is licensed under this &gt; Public License, and include the text
                of, or the URI or &gt; hyperlink to, this Public License.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; 2. You may satisfy the conditions in Section 3(a)(1) in any &gt; reasonable manner based on the
                medium, means, and context in &gt; which You Share the Licensed Material. For example, it may be &gt;
                reasonable to satisfy the conditions by providing a URI or &gt; hyperlink to a resource that includes
                the required &gt; information.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; 3. If requested by the Licensor, You must remove any of the &gt; information required by Section
                3(a)(1)(A) to the extent &gt; reasonably practicable.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; 4. If You Share Adapted Material You produce, the Adapter's &gt; License You apply must not prevent
                recipients of the Adapted &gt; Material from complying with this Public License.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Section 4 -- Sui Generis Database Rights.</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Where the Licensed Rights include Sui Generis Database Rights that &gt; apply to Your use of the
                Licensed Material:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; a. for the avoidance of doubt, Section 2(a)(1) grants You the right &gt; to extract, reuse,
                reproduce, and Share all or a substantial &gt; portion of the contents of the database;
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; b. if You include all or a substantial portion of the database &gt; contents in a database in which
                You have Sui Generis Database &gt; Rights, then the database in which You have Sui Generis Database &gt;
                Rights (but not its individual contents) is Adapted Material; and
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; c. You must comply with the conditions in Section 3(a) if You Share &gt; all or a substantial
                portion of the contents of the database.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; For the avoidance of doubt, this Section 4 supplements and does not &gt; replace Your obligations
                under this Public License where the Licensed &gt; Rights include other Copyright and Similar Rights.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Section 5 -- Disclaimer of Warranties and Limitation of Liability.</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; a. UNLESS OTHERWISE SEPARATELY UNDERTAKEN BY THE LICENSOR, TO THE &gt; EXTENT POSSIBLE, THE
                LICENSOR OFFERS THE LICENSED MATERIAL AS-IS &gt; AND AS-AVAILABLE, AND MAKES NO REPRESENTATIONS OR
                WARRANTIES OF &gt; ANY KIND CONCERNING THE LICENSED MATERIAL, WHETHER EXPRESS, &gt; IMPLIED, STATUTORY,
                OR OTHER. THIS INCLUDES, WITHOUT LIMITATION, &gt; WARRANTIES OF TITLE, MERCHANTABILITY, FITNESS FOR A
                PARTICULAR &gt; PURPOSE, NON-INFRINGEMENT, ABSENCE OF LATENT OR OTHER DEFECTS, &gt; ACCURACY, OR THE
                PRESENCE OR ABSENCE OF ERRORS, WHETHER OR NOT &gt; KNOWN OR DISCOVERABLE. WHERE DISCLAIMERS OF
                WARRANTIES ARE NOT &gt; ALLOWED IN FULL OR IN PART, THIS DISCLAIMER MAY NOT APPLY TO YOU.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; b. TO THE EXTENT POSSIBLE, IN NO EVENT WILL THE LICENSOR BE LIABLE &gt; TO YOU ON ANY LEGAL THEORY
                (INCLUDING, WITHOUT LIMITATION, &gt; NEGLIGENCE) OR OTHERWISE FOR ANY DIRECT, SPECIAL, INDIRECT, &gt;
                INCIDENTAL, CONSEQUENTIAL, PUNITIVE, EXEMPLARY, OR OTHER LOSSES, &gt; COSTS, EXPENSES, OR DAMAGES
                ARISING OUT OF THIS PUBLIC LICENSE OR &gt; USE OF THE LICENSED MATERIAL, EVEN IF THE LICENSOR HAS BEEN
                &gt; ADVISED OF THE POSSIBILITY OF SUCH LOSSES, COSTS, EXPENSES, OR &gt; DAMAGES. WHERE A LIMITATION OF
                LIABILITY IS NOT ALLOWED IN FULL OR &gt; IN PART, THIS LIMITATION MAY NOT APPLY TO YOU.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; c. The disclaimer of warranties and limitation of liability provided &gt; above shall be
                interpreted in a manner that, to the extent &gt; possible, most closely approximates an absolute
                disclaimer and &gt; waiver of all liability.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Section 6 -- Term and Termination.</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; a. This Public License applies for the term of the Copyright and &gt; Similar Rights licensed here.
                However, if You fail to comply with &gt; this Public License, then Your rights under this Public License
                &gt; terminate automatically.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; b. Where Your right to use the Licensed Material has terminated under &gt; Section 6(a), it
                reinstates:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; 1. automatically as of the date the violation is cured, provided &gt; it is cured within 30 days of
                Your discovery of the &gt; violation; or
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; 2. upon express reinstatement by the Licensor.</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; For the avoidance of doubt, this Section 6(b) does not affect any &gt; right the Licensor may have
                to seek remedies for Your violations &gt; of this Public License.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; c. For the avoidance of doubt, the Licensor may also offer the &gt; Licensed Material under
                separate terms or conditions or stop &gt; distributing the Licensed Material at any time; however, doing
                so &gt; will not terminate this Public License.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; d. Sections 1, 5, 6, 7, and 8 survive termination of this Public &gt; License.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Section 7 -- Other Terms and Conditions.</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; a. The Licensor shall not be bound by any additional or different &gt; terms or conditions
                communicated by You unless expressly agreed.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; b. Any arrangements, understandings, or agreements regarding the &gt; Licensed Material not stated
                herein are separate from and &gt; independent of the terms and conditions of this Public License.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Section 8 -- Interpretation.</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; a. For the avoidance of doubt, this Public License does not, and &gt; shall not be interpreted to,
                reduce, limit, restrict, or impose &gt; conditions on any use of the Licensed Material that could
                lawfully &gt; be made without permission under this Public License.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; b. To the extent possible, if any provision of this Public License is &gt; deemed unenforceable, it
                shall be automatically reformed to the &gt; minimum extent necessary to make it enforceable. If the
                provision &gt; cannot be reformed, it shall be severed from this Public License &gt; without affecting
                the enforceability of the remaining terms and &gt; conditions.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; c. No term or condition of this Public License will be waived and no &gt; failure to comply
                consented to unless expressly agreed to by the &gt; Licensor.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; d. Nothing in this Public License constitutes or may be interpreted &gt; as a limitation upon, or
                waiver of, any privileges and immunities &gt; that apply to the Licensor or You, including from the
                legal &gt; processes of any jurisdiction or authority.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; =======================================================================
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Creative Commons is not a party to its public &gt; licenses. Notwithstanding, Creative Commons may
                elect to apply one of &gt; its public licenses to material it publishes and in those instances &gt; will
                be considered the “Licensor.” The text of the Creative Commons &gt; public licenses is dedicated to the
                public domain under the CC0 Public &gt; Domain Dedication. Except for the limited purpose of indicating
                that &gt; material is shared under a Creative Commons public license or as &gt; otherwise permitted by
                the Creative Commons policies published at &gt; creativecommons.org/policies, Creative Commons does not
                authorize the &gt; use of the trademark "Creative Commons" or any other trademark or logo &gt; of
                Creative Commons without its prior written consent including, &gt; without limitation, in connection
                with any unauthorized modifications &gt; to any of its public licenses or any other arrangements, &gt;
                understandings, or agreements concerning use of licensed material. For &gt; the avoidance of doubt, this
                paragraph does not form part of the &gt; public licenses.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Creative Commons may be contacted at creativecommons.org.</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `colorette`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: Jorge Bucaran</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Copyright © Jorge Bucaran &lt;&lt;https://jorgebucaran.com&gt;&gt;</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a copy of this software and
                associated documentation files (the 'Software'), to deal in the Software without restriction, including
                without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
                copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the
                following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in all copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
                NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
                IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
                WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
                SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `commondir`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: [James Halliday](http://substack.net)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; The MIT License</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Copyright (c) 2013 James Halliday (mail@substack.net)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, &gt; to any person obtaining a copy of this software
                and &gt; associated documentation files (the "Software"), to &gt; deal in the Software without
                restriction, including &gt; without limitation the rights to use, copy, modify, &gt; merge, publish,
                distribute, sublicense, and/or sell &gt; copies of the Software, and to permit persons to whom &gt; the
                Software is furnished to do so, &gt; subject to the following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice &gt; shall be included in all copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, &gt; EXPRESS OR IMPLIED, INCLUDING
                BUT NOT LIMITED TO THE WARRANTIES &gt; OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
                NONINFRINGEMENT. &gt; IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR &gt; ANY CLAIM,
                DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, &gt; TORT OR OTHERWISE, ARISING FROM, OUT
                OF OR IN CONNECTION WITH THE &gt; SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `concat-map`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: [James Halliday](http://substack.net)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; This software is released under the MIT license:</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a copy of &gt; this software
                and associated documentation files (the "Software"), to deal in &gt; the Software without restriction,
                including without limitation the rights to &gt; use, copy, modify, merge, publish, distribute,
                sublicense, and/or sell copies of &gt; the Software, and to permit persons to whom the Software is
                furnished to do so, &gt; subject to the following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in all &gt; copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR &gt; IMPLIED, INCLUDING
                BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS &gt; FOR A PARTICULAR PURPOSE AND
                NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR &gt; COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                DAMAGES OR OTHER LIABILITY, WHETHER &gt; IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT
                OF OR IN &gt; CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `css`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: TJ Holowaychuk &lt;tj@vision-media.ca&gt;</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; (The MIT License)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Copyright (c) 2012 TJ Holowaychuk &lt;tj@vision-media.ca&gt;</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a copy of this software and
                associated documentation files (the 'Software'), to deal in the Software without restriction, including
                without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
                copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the
                following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in all copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
                NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
                IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
                WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
                SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `deepmerge`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Homepage: https://github.com/TehShrike/deepmerge</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; The MIT License (MIT)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Copyright (c) 2012 James Halliday, Josh Duff, and other contributors</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a copy &gt; of this software
                and associated documentation files (the "Software"), to deal &gt; in the Software without restriction,
                including without limitation the rights &gt; to use, copy, modify, merge, publish, distribute,
                sublicense, and/or sell &gt; copies of the Software, and to permit persons to whom the Software is &gt;
                furnished to do so, subject to the following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in &gt; all copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR &gt; IMPLIED, INCLUDING
                BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, &gt; FITNESS FOR A PARTICULAR PURPOSE AND
                NONINFRINGEMENT. IN NO EVENT SHALL THE &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                DAMAGES OR OTHER &gt; LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, &gt;
                OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN &gt; THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `define-lazy-prop`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: [Sindre Sorhus](sindresorhus.com)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; MIT License</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a copy of this software and
                associated documentation files (the "Software"), to deal in the Software without restriction, including
                without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
                copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the
                following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in all copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
                NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
                IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
                WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
                SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `electron-to-chromium`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: ISC</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: Kilian Valkhof</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Copyright 2018 Kilian Valkhof</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission to use, copy, modify, and/or distribute this software for any purpose with or without
                fee is hereby granted, provided that the above copyright notice and this permission notice appear in all
                copies.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH REGARD TO THIS
                SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR
                BE LIABLE FOR ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER
                RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER
                TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `escalade`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: [Luke Edwards](https://lukeed.com)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; MIT License</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Copyright (c) Luke Edwards &lt;luke.edwards05@gmail.com&gt; (lukeed.com)
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a copy of this software and
                associated documentation files (the "Software"), to deal in the Software without restriction, including
                without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
                copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the
                following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in all copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
                NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
                IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
                WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
                SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `estree-walker`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: Rich Harris</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Copyright (c) 2015-20 [these
                people](https://github.com/Rich-Harris/estree-walker/graphs/contributors)
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a copy of this software and
                associated documentation files (the "Software"), to deal in the Software without restriction, including
                without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
                copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the
                following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in all copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
                NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
                IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
                WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
                SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `exit`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: ["Cowboy" Ben Alman](http://benalman.com/)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Homepage: https://github.com/cowboy/node-exit</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Copyright (c) 2013 "Cowboy" Ben Alman</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person &gt; obtaining a copy of this software
                and associated documentation &gt; files (the "Software"), to deal in the Software without &gt;
                restriction, including without limitation the rights to use, &gt; copy, modify, merge, publish,
                distribute, sublicense, and/or sell &gt; copies of the Software, and to permit persons to whom the &gt;
                Software is furnished to do so, subject to the following &gt; conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be &gt; included in all copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, &gt; EXPRESS OR IMPLIED, INCLUDING
                BUT NOT LIMITED TO THE WARRANTIES &gt; OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND &gt;
                NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT &gt; HOLDERS BE LIABLE FOR ANY CLAIM,
                DAMAGES OR OTHER LIABILITY, &gt; WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING &gt; FROM,
                OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR &gt; OTHER DEALINGS IN THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `fast-deep-equal`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: Evgeny Poberezkin</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Homepage: https://github.com/epoberezkin/fast-deep-equal#readme</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; MIT License</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Copyright (c) 2017 Evgeny Poberezkin</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a copy &gt; of this software
                and associated documentation files (the "Software"), to deal &gt; in the Software without restriction,
                including without limitation the rights &gt; to use, copy, modify, merge, publish, distribute,
                sublicense, and/or sell &gt; copies of the Software, and to permit persons to whom the Software is &gt;
                furnished to do so, subject to the following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in all &gt; copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR &gt; IMPLIED, INCLUDING
                BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, &gt; FITNESS FOR A PARTICULAR PURPOSE AND
                NONINFRINGEMENT. IN NO EVENT SHALL THE &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                DAMAGES OR OTHER &gt; LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, &gt;
                OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE &gt; SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `fraction.js`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT OR GPL-2.0-or-later</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: Robert Eisele &lt;robert@xarg.org&gt; (http://www.xarg.org/)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Homepage: http://www.xarg.org/2014/03/rational-numbers-in-javascript/</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; MIT License</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Copyright (c) 2017 Robert Eisele</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a copy &gt; of this software
                and associated documentation files (the "Software"), to deal &gt; in the Software without restriction,
                including without limitation the rights &gt; to use, copy, modify, merge, publish, distribute,
                sublicense, and/or sell &gt; copies of the Software, and to permit persons to whom the Software is &gt;
                furnished to do so, subject to the following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in all &gt; copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR &gt; IMPLIED, INCLUDING
                BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, &gt; FITNESS FOR A PARTICULAR PURPOSE AND
                NONINFRINGEMENT. IN NO EVENT SHALL THE &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                DAMAGES OR OTHER &gt; LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, &gt;
                OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE &gt; SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `fs.realpath`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: ISC</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: Isaac Z. Schlueter &lt;i@izs.me&gt; (http://blog.izs.me/)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; The ISC License</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Copyright (c) Isaac Z. Schlueter and Contributors</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission to use, copy, modify, and/or distribute this software for any &gt; purpose with or
                without fee is hereby granted, provided that the above &gt; copyright notice and this permission notice
                appear in all copies.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES &gt; WITH REGARD TO THIS
                SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF &gt; MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE
                AUTHOR BE LIABLE FOR &gt; ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES &gt;
                WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN &gt; ACTION OF CONTRACT,
                NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR &gt; IN CONNECTION WITH THE USE OR PERFORMANCE OF
                THIS SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; ----</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; This library bundles a version of the `fs.realpath` and `fs.realpathSync` &gt; methods from Node.js
                v0.10 under the terms of the Node.js MIT license.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Node's license follows, also included at the header of `old.js` which contains &gt; the licensed
                code:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Copyright Joyent, Inc. and other Node contributors.</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a &gt; copy of this software
                and associated documentation files (the "Software"), &gt; to deal in the Software without restriction,
                including without limitation &gt; the rights to use, copy, modify, merge, publish, distribute,
                sublicense, &gt; and/or sell copies of the Software, and to permit persons to whom the &gt; Software is
                furnished to do so, subject to the following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in &gt; all copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR &gt; IMPLIED, INCLUDING
                BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, &gt; FITNESS FOR A PARTICULAR PURPOSE AND
                NONINFRINGEMENT. IN NO EVENT SHALL THE &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                DAMAGES OR OTHER &gt; LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING &gt; FROM,
                OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER &gt; DEALINGS IN THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `function-bind`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: Raynos &lt;raynos2@gmail.com&gt;</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Contributors: Raynos, [Jordan Harband](https://github.com/ljharb)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Homepage: https://github.com/Raynos/function-bind</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Copyright (c) 2013 Raynos.</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a copy &gt; of this software
                and associated documentation files (the "Software"), to deal &gt; in the Software without restriction,
                including without limitation the rights &gt; to use, copy, modify, merge, publish, distribute,
                sublicense, and/or sell &gt; copies of the Software, and to permit persons to whom the Software is &gt;
                furnished to do so, subject to the following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in &gt; all copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR &gt; IMPLIED, INCLUDING
                BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, &gt; FITNESS FOR A PARTICULAR PURPOSE AND
                NONINFRINGEMENT. IN NO EVENT SHALL THE &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                DAMAGES OR OTHER &gt; LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, &gt;
                OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN &gt; THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `glob`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: ISC</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: Isaac Z. Schlueter &lt;i@izs.me&gt; (http://blog.izs.me/)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; The ISC License</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Copyright (c) Isaac Z. Schlueter and Contributors</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission to use, copy, modify, and/or distribute this software for any &gt; purpose with or
                without fee is hereby granted, provided that the above &gt; copyright notice and this permission notice
                appear in all copies.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES &gt; WITH REGARD TO THIS
                SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF &gt; MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE
                AUTHOR BE LIABLE FOR &gt; ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES &gt;
                WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN &gt; ACTION OF CONTRACT,
                NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR &gt; IN CONNECTION WITH THE USE OR PERFORMANCE OF
                THIS SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; ## Glob Logo</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Glob's logo created by Tanya Brassie &lt;http://tanyabrassie.com/&gt;, licensed &gt; under a
                Creative Commons Attribution-ShareAlike 4.0 International License &gt;
                https://creativecommons.org/licenses/by-sa/4.0/
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `graceful-fs`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: ISC</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; The ISC License</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Copyright (c) Isaac Z. Schlueter, Ben Noordhuis, and Contributors</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission to use, copy, modify, and/or distribute this software for any &gt; purpose with or
                without fee is hereby granted, provided that the above &gt; copyright notice and this permission notice
                appear in all copies.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES &gt; WITH REGARD TO THIS
                SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF &gt; MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE
                AUTHOR BE LIABLE FOR &gt; ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES &gt;
                WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN &gt; ACTION OF CONTRACT,
                NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR &gt; IN CONNECTION WITH THE USE OR PERFORMANCE OF
                THIS SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `has`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: Thiago de Arruda</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Contributors: [Jordan Harband](http://ljharb.codes)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Homepage: https://github.com/tarruda/has</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Copyright (c) 2013 Thiago de Arruda</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person &gt; obtaining a copy of this software
                and associated documentation &gt; files (the "Software"), to deal in the Software without &gt;
                restriction, including without limitation the rights to use, &gt; copy, modify, merge, publish,
                distribute, sublicense, and/or sell &gt; copies of the Software, and to permit persons to whom the &gt;
                Software is furnished to do so, subject to the following &gt; conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be &gt; included in all copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, &gt; EXPRESS OR IMPLIED, INCLUDING
                BUT NOT LIMITED TO THE WARRANTIES &gt; OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND &gt;
                NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT &gt; HOLDERS BE LIABLE FOR ANY CLAIM,
                DAMAGES OR OTHER LIABILITY, &gt; WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING &gt; FROM,
                OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR &gt; OTHER DEALINGS IN THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `inflight`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: ISC</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: Isaac Z. Schlueter &lt;i@izs.me&gt; (http://blog.izs.me/)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Homepage: https://github.com/isaacs/inflight</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; The ISC License</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Copyright (c) Isaac Z. Schlueter</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission to use, copy, modify, and/or distribute this software for any &gt; purpose with or
                without fee is hereby granted, provided that the above &gt; copyright notice and this permission notice
                appear in all copies.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES &gt; WITH REGARD TO THIS
                SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF &gt; MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE
                AUTHOR BE LIABLE FOR &gt; ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES &gt;
                WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN &gt; ACTION OF CONTRACT,
                NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR &gt; IN CONNECTION WITH THE USE OR PERFORMANCE OF
                THIS SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `inherits`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: ISC</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; The ISC License</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Copyright (c) Isaac Z. Schlueter</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission to use, copy, modify, and/or distribute this software for any &gt; purpose with or
                without fee is hereby granted, provided that the above &gt; copyright notice and this permission notice
                appear in all copies.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH &gt; REGARD TO THIS
                SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND &gt; FITNESS. IN NO EVENT SHALL THE
                AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT, &gt; INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
                WHATSOEVER RESULTING FROM &gt; LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT,
                NEGLIGENCE OR &gt; OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR &gt;
                PERFORMANCE OF THIS SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `is-core-module`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: Jordan Harband &lt;ljharb@gmail.com&gt;</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Homepage: https://github.com/inspect-js/is-core-module</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; The MIT License (MIT)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Copyright (c) 2014 Dave Justice</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a copy of &gt; this software
                and associated documentation files (the "Software"), to deal in &gt; the Software without restriction,
                including without limitation the rights to &gt; use, copy, modify, merge, publish, distribute,
                sublicense, and/or sell copies of &gt; the Software, and to permit persons to whom the Software is
                furnished to do so, &gt; subject to the following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in all &gt; copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR &gt; IMPLIED, INCLUDING
                BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS &gt; FOR A PARTICULAR PURPOSE AND
                NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR &gt; COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                DAMAGES OR OTHER LIABILITY, WHETHER &gt; IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT
                OF OR IN &gt; CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `is-docker`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: [Sindre Sorhus](https://sindresorhus.com)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; MIT License</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (https://sindresorhus.com)
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a copy of this software and
                associated documentation files (the "Software"), to deal in the Software without restriction, including
                without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
                copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the
                following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in all copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
                NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
                IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
                WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
                SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `is-extglob`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: Jon Schlinkert (https://github.com/jonschlinkert)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Homepage: https://github.com/jonschlinkert/is-extglob</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; The MIT License (MIT)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Copyright (c) 2014-2016, Jon Schlinkert</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a copy &gt; of this software
                and associated documentation files (the "Software"), to deal &gt; in the Software without restriction,
                including without limitation the rights &gt; to use, copy, modify, merge, publish, distribute,
                sublicense, and/or sell &gt; copies of the Software, and to permit persons to whom the Software is &gt;
                furnished to do so, subject to the following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in &gt; all copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR &gt; IMPLIED, INCLUDING
                BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, &gt; FITNESS FOR A PARTICULAR PURPOSE AND
                NONINFRINGEMENT. IN NO EVENT SHALL THE &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                DAMAGES OR OTHER &gt; LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, &gt;
                OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN &gt; THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `is-module`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: [Jonathan Ong](http://jongleberry.com)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `is-reference`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: Rich Harris</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Homepage: https://github.com/Rich-Harris/is-reference#readme</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `is-wsl`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: [Sindre Sorhus](sindresorhus.com)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; MIT License</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a copy of this software and
                associated documentation files (the "Software"), to deal in the Software without restriction, including
                without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
                copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the
                following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in all copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
                NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
                IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
                WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
                SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `kleur`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: [Luke Edwards](lukeed.com)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; The MIT License (MIT)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Copyright (c) Luke Edwards &lt;luke.edwards05@gmail.com&gt; (lukeed.com)
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a copy &gt; of this software
                and associated documentation files (the "Software"), to deal &gt; in the Software without restriction,
                including without limitation the rights &gt; to use, copy, modify, merge, publish, distribute,
                sublicense, and/or sell &gt; copies of the Software, and to permit persons to whom the Software is &gt;
                furnished to do so, subject to the following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in &gt; all copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR &gt; IMPLIED, INCLUDING
                BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, &gt; FITNESS FOR A PARTICULAR PURPOSE AND
                NONINFRINGEMENT. IN NO EVENT SHALL THE &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                DAMAGES OR OTHER &gt; LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, &gt;
                OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN &gt; THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `lodash`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: John-David Dalton &lt;john.david.dalton@gmail.com&gt;</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                Contributors: John-David Dalton &lt;john.david.dalton@gmail.com&gt;, Mathias Bynens
                &lt;mathias@qiwi.be&gt;
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Homepage: https://lodash.com/</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Copyright OpenJS Foundation and other contributors &lt;https://openjsf.org/&gt;
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Based on Underscore.js, copyright Jeremy Ashkenas, &gt; DocumentCloud and Investigative Reporters
                &amp; Editors &lt;http://underscorejs.org/&gt;
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; This software consists of voluntary contributions made by many &gt; individuals. For exact
                contribution history, see the revision history &gt; available at https://github.com/lodash/lodash
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The following license applies to all parts of this software except as &gt; documented below:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; ====</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining &gt; a copy of this software
                and associated documentation files (the &gt; "Software"), to deal in the Software without restriction,
                including &gt; without limitation the rights to use, copy, modify, merge, publish, &gt; distribute,
                sublicense, and/or sell copies of the Software, and to &gt; permit persons to whom the Software is
                furnished to do so, subject to &gt; the following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be &gt; included in all copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, &gt; EXPRESS OR IMPLIED, INCLUDING
                BUT NOT LIMITED TO THE WARRANTIES OF &gt; MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND &gt;
                NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE &gt; LIABLE FOR ANY CLAIM,
                DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION &gt; OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT
                OF OR IN CONNECTION &gt; WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; ====</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Copyright and related rights for sample code are waived via CC0. Sample &gt; code is defined as all
                source code displayed within the prose of the &gt; documentation.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; CC0: http://creativecommons.org/publicdomain/zero/1.0/</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; ====</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Files located in the node_modules and vendor directories are externally &gt; maintained libraries
                used by this software which have their own &gt; licenses; we recommend you read them, as their terms may
                differ from the &gt; terms above.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `lru-cache`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: ISC</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: Isaac Z. Schlueter &lt;i@izs.me&gt;</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; The ISC License</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Copyright (c) Isaac Z. Schlueter and Contributors</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission to use, copy, modify, and/or distribute this software for any &gt; purpose with or
                without fee is hereby granted, provided that the above &gt; copyright notice and this permission notice
                appear in all copies.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES &gt; WITH REGARD TO THIS
                SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF &gt; MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE
                AUTHOR BE LIABLE FOR &gt; ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES &gt;
                WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN &gt; ACTION OF CONTRACT,
                NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR &gt; IN CONNECTION WITH THE USE OR PERFORMANCE OF
                THIS SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `magic-string`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: Rich Harris</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Copyright 2018 Rich Harris</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a copy of this software and
                associated documentation files (the "Software"), to deal in the Software without restriction, including
                without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
                copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the
                following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in all copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
                NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
                IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
                WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
                SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `merge-source-map`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: keik &lt;k4t0.kei@gmail.com&gt;</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; The MIT License (MIT)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Copyright (c) keik &lt;k4t0.kei@gmail.com&gt;</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a copy &gt; of this software
                and associated documentation files (the "Software"), to deal &gt; in the Software without restriction,
                including without limitation the rights &gt; to use, copy, modify, merge, publish, distribute,
                sublicense, and/or sell &gt; copies of the Software, and to permit persons to whom the Software is &gt;
                furnished to do so, subject to the following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in &gt; all copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR &gt; IMPLIED, INCLUDING
                BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, &gt; FITNESS FOR A PARTICULAR PURPOSE AND
                NONINFRINGEMENT. IN NO EVENT SHALL THE &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                DAMAGES OR OTHER &gt; LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, &gt;
                OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN &gt; THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `minimatch`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: ISC</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: Isaac Z. Schlueter &lt;i@izs.me&gt; (http://blog.izs.me)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; The ISC License</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Copyright (c) Isaac Z. Schlueter and Contributors</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission to use, copy, modify, and/or distribute this software for any &gt; purpose with or
                without fee is hereby granted, provided that the above &gt; copyright notice and this permission notice
                appear in all copies.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES &gt; WITH REGARD TO THIS
                SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF &gt; MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE
                AUTHOR BE LIABLE FOR &gt; ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES &gt;
                WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN &gt; ACTION OF CONTRACT,
                NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR &gt; IN CONNECTION WITH THE USE OR PERFORMANCE OF
                THIS SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `nanoid`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: Andrey Sitnik &lt;andrey@sitnik.ru&gt;</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; The MIT License (MIT)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Copyright 2017 Andrey Sitnik &lt;andrey@sitnik.ru&gt;</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a copy of &gt; this software
                and associated documentation files (the "Software"), to deal in &gt; the Software without restriction,
                including without limitation the rights to &gt; use, copy, modify, merge, publish, distribute,
                sublicense, and/or sell copies of &gt; the Software, and to permit persons to whom the Software is
                furnished to do so, &gt; subject to the following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in all &gt; copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR &gt; IMPLIED, INCLUDING
                BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS &gt; FOR A PARTICULAR PURPOSE AND
                NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR &gt; COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                DAMAGES OR OTHER LIABILITY, WHETHER &gt; IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT
                OF OR IN &gt; CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `node-fetch`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: David Frank</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Homepage: https://github.com/bitinn/node-fetch</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; The MIT License (MIT)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Copyright (c) 2016 David Frank</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a copy &gt; of this software
                and associated documentation files (the "Software"), to deal &gt; in the Software without restriction,
                including without limitation the rights &gt; to use, copy, modify, merge, publish, distribute,
                sublicense, and/or sell &gt; copies of the Software, and to permit persons to whom the Software is &gt;
                furnished to do so, subject to the following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in all &gt; copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR &gt; IMPLIED, INCLUDING
                BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, &gt; FITNESS FOR A PARTICULAR PURPOSE AND
                NONINFRINGEMENT. IN NO EVENT SHALL THE &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                DAMAGES OR OTHER &gt; LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, &gt;
                OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE &gt; SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `node-releases`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: Sergey Rubanov &lt;chi187@gmail.com&gt;</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; The MIT License</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Copyright (c) 2017 Sergey Rubanov (https://github.com/chicoxyzzy)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a copy &gt; of this software
                and associated documentation files (the "Software"), to deal &gt; in the Software without restriction,
                including without limitation the rights &gt; to use, copy, modify, merge, publish, distribute,
                sublicense, and/or sell &gt; copies of the Software, and to permit persons to whom the Software is &gt;
                furnished to do so, subject to the following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in &gt; all copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR &gt; IMPLIED, INCLUDING
                BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, &gt; FITNESS FOR A PARTICULAR PURPOSE AND
                NONINFRINGEMENT. IN NO EVENT SHALL THE &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                DAMAGES OR OTHER &gt; LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, &gt;
                OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN &gt; THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `normalize-range`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: [James Talmage](github.com/jamestalmage)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; The MIT License (MIT)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Copyright (c) James Talmage &lt;james@talmage.io&gt; (github.com/jamestalmage)
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a copy &gt; of this software
                and associated documentation files (the "Software"), to deal &gt; in the Software without restriction,
                including without limitation the rights &gt; to use, copy, modify, merge, publish, distribute,
                sublicense, and/or sell &gt; copies of the Software, and to permit persons to whom the Software is &gt;
                furnished to do so, subject to the following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in &gt; all copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR &gt; IMPLIED, INCLUDING
                BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, &gt; FITNESS FOR A PARTICULAR PURPOSE AND
                NONINFRINGEMENT. IN NO EVENT SHALL THE &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                DAMAGES OR OTHER &gt; LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, &gt;
                OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN &gt; THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `once`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: ISC</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: Isaac Z. Schlueter &lt;i@izs.me&gt; (http://blog.izs.me/)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; The ISC License</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Copyright (c) Isaac Z. Schlueter and Contributors</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission to use, copy, modify, and/or distribute this software for any &gt; purpose with or
                without fee is hereby granted, provided that the above &gt; copyright notice and this permission notice
                appear in all copies.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES &gt; WITH REGARD TO THIS
                SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF &gt; MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE
                AUTHOR BE LIABLE FOR &gt; ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES &gt;
                WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN &gt; ACTION OF CONTRACT,
                NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR &gt; IN CONNECTION WITH THE USE OR PERFORMANCE OF
                THIS SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `open`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: [Sindre Sorhus](https://sindresorhus.com)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; MIT License</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (https://sindresorhus.com)
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a copy of this software and
                associated documentation files (the "Software"), to deal in the Software without restriction, including
                without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
                copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the
                following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in all copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
                NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
                IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
                WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
                SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `parse5`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                Author: Ivan Nikulin &lt;ifaaan@gmail.com&gt; (https://github.com/inikulin)
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Contributors: https://github.com/inikulin/parse5/graphs/contributors</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Homepage: https://github.com/inikulin/parse5</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Copyright (c) 2013-2019 Ivan Nikulin (ifaaan@gmail.com, https://github.com/inikulin)
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a copy &gt; of this software
                and associated documentation files (the "Software"), to deal &gt; in the Software without restriction,
                including without limitation the rights &gt; to use, copy, modify, merge, publish, distribute,
                sublicense, and/or sell &gt; copies of the Software, and to permit persons to whom the Software is &gt;
                furnished to do so, subject to the following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in &gt; all copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR &gt; IMPLIED, INCLUDING
                BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, &gt; FITNESS FOR A PARTICULAR PURPOSE AND
                NONINFRINGEMENT. IN NO EVENT SHALL THE &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                DAMAGES OR OTHER &gt; LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, &gt;
                OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN &gt; THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `path-is-absolute`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: [Sindre Sorhus](sindresorhus.com)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; The MIT License (MIT)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a copy &gt; of this software
                and associated documentation files (the "Software"), to deal &gt; in the Software without restriction,
                including without limitation the rights &gt; to use, copy, modify, merge, publish, distribute,
                sublicense, and/or sell &gt; copies of the Software, and to permit persons to whom the Software is &gt;
                furnished to do so, subject to the following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in &gt; all copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR &gt; IMPLIED, INCLUDING
                BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, &gt; FITNESS FOR A PARTICULAR PURPOSE AND
                NONINFRINGEMENT. IN NO EVENT SHALL THE &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                DAMAGES OR OTHER &gt; LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, &gt;
                OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN &gt; THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `path-parse`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: Javier Blanco &lt;http://jbgutierrez.info&gt;</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Homepage: https://github.com/jbgutierrez/path-parse#readme</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; The MIT License (MIT)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Copyright (c) 2015 Javier Blanco</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a copy &gt; of this software
                and associated documentation files (the "Software"), to deal &gt; in the Software without restriction,
                including without limitation the rights &gt; to use, copy, modify, merge, publish, distribute,
                sublicense, and/or sell &gt; copies of the Software, and to permit persons to whom the Software is &gt;
                furnished to do so, subject to the following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in all &gt; copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR &gt; IMPLIED, INCLUDING
                BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, &gt; FITNESS FOR A PARTICULAR PURPOSE AND
                NONINFRINGEMENT. IN NO EVENT SHALL THE &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                DAMAGES OR OTHER &gt; LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, &gt;
                OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE &gt; SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `picocolors`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: ISC</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: Alexey Raspopov</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; ISC License</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Copyright (c) 2021 Alexey Raspopov, Kostiantyn Denysov, Anton Verinov
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission to use, copy, modify, and/or distribute this software for any &gt; purpose with or
                without fee is hereby granted, provided that the above &gt; copyright notice and this permission notice
                appear in all copies.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES &gt; WITH REGARD TO THIS
                SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF &gt; MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE
                AUTHOR BE LIABLE FOR &gt; ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES &gt;
                WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN &gt; ACTION OF CONTRACT,
                NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF &gt; OR IN CONNECTION WITH THE USE OR PERFORMANCE OF
                THIS SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `picomatch`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: Jon Schlinkert (https://github.com/jonschlinkert)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Homepage: https://github.com/micromatch/picomatch</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; The MIT License (MIT)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Copyright (c) 2017-present, Jon Schlinkert.</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a copy &gt; of this software
                and associated documentation files (the "Software"), to deal &gt; in the Software without restriction,
                including without limitation the rights &gt; to use, copy, modify, merge, publish, distribute,
                sublicense, and/or sell &gt; copies of the Software, and to permit persons to whom the Software is &gt;
                furnished to do so, subject to the following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in &gt; all copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR &gt; IMPLIED, INCLUDING
                BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, &gt; FITNESS FOR A PARTICULAR PURPOSE AND
                NONINFRINGEMENT. IN NO EVENT SHALL THE &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                DAMAGES OR OTHER &gt; LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, &gt;
                OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN &gt; THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `pixelmatch`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: ISC</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: Vladimir Agafonkin</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Homepage: https://github.com/mapbox/pixelmatch#readme</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; ISC License</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Copyright (c) 2015, Mapbox</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission to use, copy, modify, and/or distribute this software for any purpose &gt; with or
                without fee is hereby granted, provided that the above copyright notice &gt; and this permission notice
                appear in all copies.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH &gt; REGARD TO THIS
                SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND &gt; FITNESS. IN NO EVENT SHALL THE
                AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT, &gt; INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
                WHATSOEVER RESULTING FROM LOSS &gt; OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT,
                NEGLIGENCE OR OTHER &gt; TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF
                &gt; THIS SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `pngjs`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                Contributors: Alexandre Paré, Gaurav Mali, Gusts Kaksis, Kuba Niegowski, Luke Page, Pietajan De Potter,
                Steven Sojka, liangzeng, Michael Vogt, Xin-Xin Wang, toriningen, Eugene Kulabuhov
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Homepage: https://github.com/lukeapage/pngjs</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; pngjs2 original work Copyright (c) 2015 Luke Page &amp; Original Contributors &gt; pngjs derived
                work Copyright (c) 2012 Kuba Niegowski
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a copy &gt; of this software
                and associated documentation files (the "Software"), to deal &gt; in the Software without restriction,
                including without limitation the rights &gt; to use, copy, modify, merge, publish, distribute,
                sublicense, and/or sell &gt; copies of the Software, and to permit persons to whom the Software is &gt;
                furnished to do so, subject to the following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in &gt; all copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR &gt; IMPLIED, INCLUDING
                BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, &gt; FITNESS FOR A PARTICULAR PURPOSE AND
                NONINFRINGEMENT. IN NO EVENT SHALL THE &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                DAMAGES OR OTHER &gt; LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, &gt;
                OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN &gt; THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `postcss`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: Andrey Sitnik &lt;andrey@sitnik.ru&gt;</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Homepage: https://postcss.org/</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; The MIT License (MIT)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Copyright 2013 Andrey Sitnik &lt;andrey@sitnik.ru&gt;</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a copy of &gt; this software
                and associated documentation files (the "Software"), to deal in &gt; the Software without restriction,
                including without limitation the rights to &gt; use, copy, modify, merge, publish, distribute,
                sublicense, and/or sell copies of &gt; the Software, and to permit persons to whom the Software is
                furnished to do so, &gt; subject to the following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in all &gt; copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR &gt; IMPLIED, INCLUDING
                BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS &gt; FOR A PARTICULAR PURPOSE AND
                NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR &gt; COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                DAMAGES OR OTHER LIABILITY, WHETHER &gt; IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT
                OF OR IN &gt; CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `postcss-value-parser`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: Bogdan Chadkin &lt;trysound@yandex.ru&gt;</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Homepage: https://github.com/TrySound/postcss-value-parser</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Copyright (c) Bogdan Chadkin &lt;trysound@yandex.ru&gt;</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person &gt; obtaining a copy of this software
                and associated documentation &gt; files (the "Software"), to deal in the Software without &gt;
                restriction, including without limitation the rights to use, &gt; copy, modify, merge, publish,
                distribute, sublicense, and/or sell &gt; copies of the Software, and to permit persons to whom the &gt;
                Software is furnished to do so, subject to the following &gt; conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be &gt; included in all copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, &gt; EXPRESS OR IMPLIED, INCLUDING
                BUT NOT LIMITED TO THE WARRANTIES &gt; OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND &gt;
                NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT &gt; HOLDERS BE LIABLE FOR ANY CLAIM,
                DAMAGES OR OTHER LIABILITY, &gt; WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING &gt; FROM,
                OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR &gt; OTHER DEALINGS IN THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `prompts`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: [Terkel Gjervig](https://terkel.com)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; MIT License</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Copyright (c) 2018 Terkel Gjervig Nielsen</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a copy &gt; of this software
                and associated documentation files (the "Software"), to deal &gt; in the Software without restriction,
                including without limitation the rights &gt; to use, copy, modify, merge, publish, distribute,
                sublicense, and/or sell &gt; copies of the Software, and to permit persons to whom the Software is &gt;
                furnished to do so, subject to the following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in all &gt; copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR &gt; IMPLIED, INCLUDING
                BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, &gt; FITNESS FOR A PARTICULAR PURPOSE AND
                NONINFRINGEMENT. IN NO EVENT SHALL THE &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                DAMAGES OR OTHER &gt; LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, &gt;
                OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE &gt; SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `punycode`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: [Mathias Bynens](https://mathiasbynens.be/)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Contributors: [Mathias Bynens](https://mathiasbynens.be/)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Homepage: https://mths.be/punycode</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `resolve`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: [James Halliday](http://substack.net)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; MIT License</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Copyright (c) 2012 James Halliday</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a copy &gt; of this software
                and associated documentation files (the "Software"), to deal &gt; in the Software without restriction,
                including without limitation the rights &gt; to use, copy, modify, merge, publish, distribute,
                sublicense, and/or sell &gt; copies of the Software, and to permit persons to whom the Software is &gt;
                furnished to do so, subject to the following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in all &gt; copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR &gt; IMPLIED, INCLUDING
                BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, &gt; FITNESS FOR A PARTICULAR PURPOSE AND
                NONINFRINGEMENT. IN NO EVENT SHALL THE &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                DAMAGES OR OTHER &gt; LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, &gt;
                OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE &gt; SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `rollup`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: Rich Harris</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Homepage: https://rollupjs.org/</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; # Rollup core license &gt; Rollup is released under the MIT license:</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; The MIT License (MIT)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Copyright (c) 2017 [these people](https://github.com/rollup/rollup/graphs/contributors)
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a copy &gt; of this software
                and associated documentation files (the "Software"), to deal &gt; in the Software without restriction,
                including without limitation the rights &gt; to use, copy, modify, merge, publish, distribute,
                sublicense, and/or sell &gt; copies of the Software, and to permit persons to whom the Software is &gt;
                furnished to do so, subject to the following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in &gt; all copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR &gt; IMPLIED, INCLUDING
                BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, &gt; FITNESS FOR A PARTICULAR PURPOSE AND
                NONINFRINGEMENT. IN NO EVENT SHALL THE &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                DAMAGES OR OTHER &gt; LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, &gt;
                OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN &gt; THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; # Licenses of bundled dependencies &gt; The published Rollup artifact additionally contains code
                with the following licenses: &gt; MIT, ISC
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; # Bundled dependencies: &gt; ## acorn &gt; License: MIT &gt; By: Marijn Haverbeke, Ingvar
                Stepanyan, Adrian Heine &gt; Repository: https://github.com/acornjs/acorn.git
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; &gt; MIT License &gt; &gt; &gt; &gt; Copyright (C) 2012-2020 by various contributors (see AUTHORS)
                &gt; &gt; &gt; &gt; Permission is hereby granted, free of charge, to any person obtaining a copy &gt;
                &gt; of this software and associated documentation files (the "Software"), to deal &gt; &gt; in the
                Software without restriction, including without limitation the rights &gt; &gt; to use, copy, modify,
                merge, publish, distribute, sublicense, and/or sell &gt; &gt; copies of the Software, and to permit
                persons to whom the Software is &gt; &gt; furnished to do so, subject to the following conditions: &gt;
                &gt; &gt; &gt; The above copyright notice and this permission notice shall be included in &gt; &gt; all
                copies or substantial portions of the Software. &gt; &gt; &gt; &gt; THE SOFTWARE IS PROVIDED "AS IS",
                WITHOUT WARRANTY OF ANY KIND, EXPRESS OR &gt; &gt; IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
                OF MERCHANTABILITY, &gt; &gt; FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL
                THE &gt; &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER &gt; &gt;
                LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, &gt; &gt; OUT OF OR IN
                CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN &gt; &gt; THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; ---------------------------------------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; ## acorn-class-fields &gt; License: MIT &gt; By: Adrian Heine &gt; Repository:
                https://github.com/acornjs/acorn-class-fields
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; &gt; Copyright (C) 2017-2018 by Adrian Heine &gt; &gt; &gt; &gt; Permission is hereby granted, free
                of charge, to any person obtaining a copy &gt; &gt; of this software and associated documentation files
                (the "Software"), to deal &gt; &gt; in the Software without restriction, including without limitation
                the rights &gt; &gt; to use, copy, modify, merge, publish, distribute, sublicense, and/or sell &gt; &gt;
                copies of the Software, and to permit persons to whom the Software is &gt; &gt; furnished to do so,
                subject to the following conditions: &gt; &gt; &gt; &gt; The above copyright notice and this permission
                notice shall be included in &gt; &gt; all copies or substantial portions of the Software. &gt; &gt; &gt;
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR &gt; &gt; IMPLIED,
                INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, &gt; &gt; FITNESS FOR A PARTICULAR
                PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE &gt; &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR
                ANY CLAIM, DAMAGES OR OTHER &gt; &gt; LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
                ARISING FROM, &gt; &gt; OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN &gt;
                &gt; THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; ---------------------------------------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; ## acorn-private-class-elements &gt; License: MIT &gt; By: Adrian Heine &gt; Repository:
                https://github.com/acornjs/acorn-private-class-elements
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; &gt; Copyright (C) 2017-2018 by Adrian Heine &gt; &gt; &gt; &gt; Permission is hereby granted, free
                of charge, to any person obtaining a copy &gt; &gt; of this software and associated documentation files
                (the "Software"), to deal &gt; &gt; in the Software without restriction, including without limitation
                the rights &gt; &gt; to use, copy, modify, merge, publish, distribute, sublicense, and/or sell &gt; &gt;
                copies of the Software, and to permit persons to whom the Software is &gt; &gt; furnished to do so,
                subject to the following conditions: &gt; &gt; &gt; &gt; The above copyright notice and this permission
                notice shall be included in &gt; &gt; all copies or substantial portions of the Software. &gt; &gt; &gt;
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR &gt; &gt; IMPLIED,
                INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, &gt; &gt; FITNESS FOR A PARTICULAR
                PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE &gt; &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR
                ANY CLAIM, DAMAGES OR OTHER &gt; &gt; LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
                ARISING FROM, &gt; &gt; OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN &gt;
                &gt; THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; ---------------------------------------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; ## acorn-static-class-features &gt; License: MIT &gt; By: Adrian Heine &gt; Repository:
                https://github.com/acornjs/acorn-static-class-features
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; &gt; Copyright (C) 2017-2018 by Adrian Heine &gt; &gt; &gt; &gt; Permission is hereby granted, free
                of charge, to any person obtaining a copy &gt; &gt; of this software and associated documentation files
                (the "Software"), to deal &gt; &gt; in the Software without restriction, including without limitation
                the rights &gt; &gt; to use, copy, modify, merge, publish, distribute, sublicense, and/or sell &gt; &gt;
                copies of the Software, and to permit persons to whom the Software is &gt; &gt; furnished to do so,
                subject to the following conditions: &gt; &gt; &gt; &gt; The above copyright notice and this permission
                notice shall be included in &gt; &gt; all copies or substantial portions of the Software. &gt; &gt; &gt;
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR &gt; &gt; IMPLIED,
                INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, &gt; &gt; FITNESS FOR A PARTICULAR
                PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE &gt; &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR
                ANY CLAIM, DAMAGES OR OTHER &gt; &gt; LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
                ARISING FROM, &gt; &gt; OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN &gt;
                &gt; THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; ---------------------------------------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; ## acorn-walk &gt; License: MIT &gt; By: Marijn Haverbeke, Ingvar Stepanyan, Adrian Heine &gt;
                Repository: https://github.com/acornjs/acorn.git
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; &gt; MIT License &gt; &gt; &gt; &gt; Copyright (C) 2012-2020 by various contributors (see AUTHORS)
                &gt; &gt; &gt; &gt; Permission is hereby granted, free of charge, to any person obtaining a copy &gt;
                &gt; of this software and associated documentation files (the "Software"), to deal &gt; &gt; in the
                Software without restriction, including without limitation the rights &gt; &gt; to use, copy, modify,
                merge, publish, distribute, sublicense, and/or sell &gt; &gt; copies of the Software, and to permit
                persons to whom the Software is &gt; &gt; furnished to do so, subject to the following conditions: &gt;
                &gt; &gt; &gt; The above copyright notice and this permission notice shall be included in &gt; &gt; all
                copies or substantial portions of the Software. &gt; &gt; &gt; &gt; THE SOFTWARE IS PROVIDED "AS IS",
                WITHOUT WARRANTY OF ANY KIND, EXPRESS OR &gt; &gt; IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
                OF MERCHANTABILITY, &gt; &gt; FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL
                THE &gt; &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER &gt; &gt;
                LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, &gt; &gt; OUT OF OR IN
                CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN &gt; &gt; THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; ---------------------------------------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; ## anymatch &gt; License: ISC &gt; By: Elan Shanker &gt; Repository:
                https://github.com/micromatch/anymatch
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; &gt; The ISC License &gt; &gt; &gt; &gt; Copyright (c) 2019 Elan Shanker, Paul Miller
                (https://paulmillr.com) &gt; &gt; &gt; &gt; Permission to use, copy, modify, and/or distribute this
                software for any &gt; &gt; purpose with or without fee is hereby granted, provided that the above &gt;
                &gt; copyright notice and this permission notice appear in all copies. &gt; &gt; &gt; &gt; THE SOFTWARE
                IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES &gt; &gt; WITH REGARD TO THIS SOFTWARE
                INCLUDING ALL IMPLIED WARRANTIES OF &gt; &gt; MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR
                BE LIABLE FOR &gt; &gt; ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES &gt; &gt;
                WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN &gt; &gt; ACTION OF CONTRACT,
                NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR &gt; &gt; IN CONNECTION WITH THE USE OR
                PERFORMANCE OF THIS SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; ---------------------------------------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; ## binary-extensions &gt; License: MIT &gt; By: Sindre Sorhus &gt; Repository:
                sindresorhus/binary-extensions
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; ---------------------------------------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; ## braces &gt; License: MIT &gt; By: Jon Schlinkert, Brian Woodward, Elan Shanker, Eugene Sharygin,
                hemanth.hm &gt; Repository: micromatch/braces
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; &gt; The MIT License (MIT) &gt; &gt; &gt; &gt; Copyright (c) 2014-2018, Jon Schlinkert. &gt; &gt;
                &gt; &gt; Permission is hereby granted, free of charge, to any person obtaining a copy &gt; &gt; of this
                software and associated documentation files (the "Software"), to deal &gt; &gt; in the Software without
                restriction, including without limitation the rights &gt; &gt; to use, copy, modify, merge, publish,
                distribute, sublicense, and/or sell &gt; &gt; copies of the Software, and to permit persons to whom the
                Software is &gt; &gt; furnished to do so, subject to the following conditions: &gt; &gt; &gt; &gt; The
                above copyright notice and this permission notice shall be included in &gt; &gt; all copies or
                substantial portions of the Software. &gt; &gt; &gt; &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
                WARRANTY OF ANY KIND, EXPRESS OR &gt; &gt; IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                MERCHANTABILITY, &gt; &gt; FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
                &gt; &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER &gt; &gt; LIABILITY,
                WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, &gt; &gt; OUT OF OR IN CONNECTION
                WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN &gt; &gt; THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; ---------------------------------------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; ## chokidar &gt; License: MIT &gt; By: Paul Miller, Elan Shanker &gt; Repository:
                git+https://github.com/paulmillr/chokidar.git
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; &gt; The MIT License (MIT) &gt; &gt; &gt; &gt; Copyright (c) 2012-2019 Paul Miller
                (https://paulmillr.com), Elan Shanker &gt; &gt; &gt; &gt; Permission is hereby granted, free of charge,
                to any person obtaining a copy &gt; &gt; of this software and associated documentation files (the
                “Software”), to deal &gt; &gt; in the Software without restriction, including without limitation the
                rights &gt; &gt; to use, copy, modify, merge, publish, distribute, sublicense, and/or sell &gt; &gt;
                copies of the Software, and to permit persons to whom the Software is &gt; &gt; furnished to do so,
                subject to the following conditions: &gt; &gt; &gt; &gt; The above copyright notice and this permission
                notice shall be included in &gt; &gt; all copies or substantial portions of the Software. &gt; &gt; &gt;
                &gt; THE SOFTWARE IS PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR &gt; &gt; IMPLIED,
                INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, &gt; &gt; FITNESS FOR A PARTICULAR
                PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE &gt; &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR
                ANY CLAIM, DAMAGES OR OTHER &gt; &gt; LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
                ARISING FROM, &gt; &gt; OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN &gt;
                &gt; THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; ---------------------------------------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; ## colorette &gt; License: MIT &gt; By: Jorge Bucaran &gt; Repository: jorgebucaran/colorette
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; &gt; Copyright © Jorge Bucaran &lt;&lt;https://jorgebucaran.com&gt;&gt; &gt; &gt; &gt; &gt;
                Permission is hereby granted, free of charge, to any person obtaining a copy of this software and
                associated documentation files (the 'Software'), to deal in the Software without restriction, including
                without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
                copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the
                following conditions: &gt; &gt; &gt; &gt; The above copyright notice and this permission notice shall be
                included in all copies or substantial portions of the Software. &gt; &gt; &gt; &gt; THE SOFTWARE IS
                PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
                WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL
                THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
                ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                USE OR OTHER DEALINGS IN THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; ---------------------------------------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; ## date-time &gt; License: MIT &gt; By: Sindre Sorhus &gt; Repository: sindresorhus/date-time
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; ---------------------------------------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; ## fill-range &gt; License: MIT &gt; By: Jon Schlinkert, Edo Rivai, Paul Miller, Rouven Weßling
                &gt; Repository: jonschlinkert/fill-range
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; &gt; The MIT License (MIT) &gt; &gt; &gt; &gt; Copyright (c) 2014-present, Jon Schlinkert. &gt;
                &gt; &gt; &gt; Permission is hereby granted, free of charge, to any person obtaining a copy &gt; &gt; of
                this software and associated documentation files (the "Software"), to deal &gt; &gt; in the Software
                without restriction, including without limitation the rights &gt; &gt; to use, copy, modify, merge,
                publish, distribute, sublicense, and/or sell &gt; &gt; copies of the Software, and to permit persons to
                whom the Software is &gt; &gt; furnished to do so, subject to the following conditions: &gt; &gt; &gt;
                &gt; The above copyright notice and this permission notice shall be included in &gt; &gt; all copies or
                substantial portions of the Software. &gt; &gt; &gt; &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
                WARRANTY OF ANY KIND, EXPRESS OR &gt; &gt; IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                MERCHANTABILITY, &gt; &gt; FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
                &gt; &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER &gt; &gt; LIABILITY,
                WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, &gt; &gt; OUT OF OR IN CONNECTION
                WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN &gt; &gt; THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; ---------------------------------------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; ## glob-parent &gt; License: ISC &gt; By: Gulp Team, Elan Shanker, Blaine Bublitz &gt; Repository:
                gulpjs/glob-parent
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; &gt; The ISC License &gt; &gt; &gt; &gt; Copyright (c) 2015, 2019 Elan Shanker &gt; &gt; &gt; &gt;
                Permission to use, copy, modify, and/or distribute this software for any &gt; &gt; purpose with or
                without fee is hereby granted, provided that the above &gt; &gt; copyright notice and this permission
                notice appear in all copies. &gt; &gt; &gt; &gt; THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR
                DISCLAIMS ALL WARRANTIES &gt; &gt; WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF &gt;
                &gt; MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR &gt; &gt; ANY SPECIAL,
                DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES &gt; &gt; WHATSOEVER RESULTING FROM LOSS OF
                USE, DATA OR PROFITS, WHETHER IN AN &gt; &gt; ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION,
                ARISING OUT OF OR &gt; &gt; IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; ---------------------------------------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; ## hash.js &gt; License: MIT &gt; By: Fedor Indutny &gt; Repository: git@github.com:indutny/hash.js
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; ---------------------------------------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; ## inherits &gt; License: ISC &gt; Repository: git://github.com/isaacs/inherits
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; &gt; The ISC License &gt; &gt; &gt; &gt; Copyright (c) Isaac Z. Schlueter &gt; &gt; &gt; &gt;
                Permission to use, copy, modify, and/or distribute this software for any &gt; &gt; purpose with or
                without fee is hereby granted, provided that the above &gt; &gt; copyright notice and this permission
                notice appear in all copies. &gt; &gt; &gt; &gt; THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR
                DISCLAIMS ALL WARRANTIES WITH &gt; &gt; REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
                MERCHANTABILITY AND &gt; &gt; FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
                &gt; &gt; INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM &gt; &gt; LOSS OF
                USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR &gt; &gt; OTHER TORTIOUS ACTION,
                ARISING OUT OF OR IN CONNECTION WITH THE USE OR &gt; &gt; PERFORMANCE OF THIS SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; ---------------------------------------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; ## is-binary-path &gt; License: MIT &gt; By: Sindre Sorhus &gt; Repository:
                sindresorhus/is-binary-path
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; ---------------------------------------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; ## is-extglob &gt; License: MIT &gt; By: Jon Schlinkert &gt; Repository: jonschlinkert/is-extglob
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; &gt; The MIT License (MIT) &gt; &gt; &gt; &gt; Copyright (c) 2014-2016, Jon Schlinkert &gt; &gt;
                &gt; &gt; Permission is hereby granted, free of charge, to any person obtaining a copy &gt; &gt; of this
                software and associated documentation files (the "Software"), to deal &gt; &gt; in the Software without
                restriction, including without limitation the rights &gt; &gt; to use, copy, modify, merge, publish,
                distribute, sublicense, and/or sell &gt; &gt; copies of the Software, and to permit persons to whom the
                Software is &gt; &gt; furnished to do so, subject to the following conditions: &gt; &gt; &gt; &gt; The
                above copyright notice and this permission notice shall be included in &gt; &gt; all copies or
                substantial portions of the Software. &gt; &gt; &gt; &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
                WARRANTY OF ANY KIND, EXPRESS OR &gt; &gt; IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                MERCHANTABILITY, &gt; &gt; FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
                &gt; &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER &gt; &gt; LIABILITY,
                WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, &gt; &gt; OUT OF OR IN CONNECTION
                WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN &gt; &gt; THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; ---------------------------------------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; ## is-glob &gt; License: MIT &gt; By: Jon Schlinkert, Brian Woodward, Daniel Perez &gt; Repository:
                micromatch/is-glob
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; &gt; The MIT License (MIT) &gt; &gt; &gt; &gt; Copyright (c) 2014-2017, Jon Schlinkert. &gt; &gt;
                &gt; &gt; Permission is hereby granted, free of charge, to any person obtaining a copy &gt; &gt; of this
                software and associated documentation files (the "Software"), to deal &gt; &gt; in the Software without
                restriction, including without limitation the rights &gt; &gt; to use, copy, modify, merge, publish,
                distribute, sublicense, and/or sell &gt; &gt; copies of the Software, and to permit persons to whom the
                Software is &gt; &gt; furnished to do so, subject to the following conditions: &gt; &gt; &gt; &gt; The
                above copyright notice and this permission notice shall be included in &gt; &gt; all copies or
                substantial portions of the Software. &gt; &gt; &gt; &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
                WARRANTY OF ANY KIND, EXPRESS OR &gt; &gt; IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                MERCHANTABILITY, &gt; &gt; FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
                &gt; &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER &gt; &gt; LIABILITY,
                WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, &gt; &gt; OUT OF OR IN CONNECTION
                WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN &gt; &gt; THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; ---------------------------------------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; ## is-number &gt; License: MIT &gt; By: Jon Schlinkert, Olsten Larck, Rouven Weßling &gt;
                Repository: jonschlinkert/is-number
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; &gt; The MIT License (MIT) &gt; &gt; &gt; &gt; Copyright (c) 2014-present, Jon Schlinkert. &gt;
                &gt; &gt; &gt; Permission is hereby granted, free of charge, to any person obtaining a copy &gt; &gt; of
                this software and associated documentation files (the "Software"), to deal &gt; &gt; in the Software
                without restriction, including without limitation the rights &gt; &gt; to use, copy, modify, merge,
                publish, distribute, sublicense, and/or sell &gt; &gt; copies of the Software, and to permit persons to
                whom the Software is &gt; &gt; furnished to do so, subject to the following conditions: &gt; &gt; &gt;
                &gt; The above copyright notice and this permission notice shall be included in &gt; &gt; all copies or
                substantial portions of the Software. &gt; &gt; &gt; &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
                WARRANTY OF ANY KIND, EXPRESS OR &gt; &gt; IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                MERCHANTABILITY, &gt; &gt; FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
                &gt; &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER &gt; &gt; LIABILITY,
                WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, &gt; &gt; OUT OF OR IN CONNECTION
                WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN &gt; &gt; THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; ---------------------------------------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; ## is-reference &gt; License: MIT &gt; By: Rich Harris &gt; Repository:
                git+https://github.com/Rich-Harris/is-reference.git
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; ---------------------------------------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; ## locate-character &gt; License: MIT &gt; By: Rich Harris &gt; Repository:
                Rich-Harris/locate-character
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; ---------------------------------------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; ## magic-string &gt; License: MIT &gt; By: Rich Harris &gt; Repository:
                https://github.com/rich-harris/magic-string
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; &gt; Copyright 2018 Rich Harris &gt; &gt; &gt; &gt; Permission is hereby granted, free of charge,
                to any person obtaining a copy of this software and associated documentation files (the "Software"), to
                deal in the Software without restriction, including without limitation the rights to use, copy, modify,
                merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to
                whom the Software is furnished to do so, subject to the following conditions: &gt; &gt; &gt; &gt; The
                above copyright notice and this permission notice shall be included in all copies or substantial
                portions of the Software. &gt; &gt; &gt; &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY
                KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
                PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR
                ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
                FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; ---------------------------------------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; ## micromatch &gt; License: MIT &gt; By: Jon Schlinkert, Amila Welihinda, Bogdan Chadkin, Brian
                Woodward, Devon Govett, Elan Shanker, Fabrício Matté, Martin Kolárik, Olsten Larck, Paul Miller, Tom
                Byrer, Tyler Akins, Peter Bright &gt; Repository: micromatch/micromatch
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; &gt; The MIT License (MIT) &gt; &gt; &gt; &gt; Copyright (c) 2014-present, Jon Schlinkert. &gt;
                &gt; &gt; &gt; Permission is hereby granted, free of charge, to any person obtaining a copy &gt; &gt; of
                this software and associated documentation files (the "Software"), to deal &gt; &gt; in the Software
                without restriction, including without limitation the rights &gt; &gt; to use, copy, modify, merge,
                publish, distribute, sublicense, and/or sell &gt; &gt; copies of the Software, and to permit persons to
                whom the Software is &gt; &gt; furnished to do so, subject to the following conditions: &gt; &gt; &gt;
                &gt; The above copyright notice and this permission notice shall be included in &gt; &gt; all copies or
                substantial portions of the Software. &gt; &gt; &gt; &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
                WARRANTY OF ANY KIND, EXPRESS OR &gt; &gt; IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                MERCHANTABILITY, &gt; &gt; FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
                &gt; &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER &gt; &gt; LIABILITY,
                WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, &gt; &gt; OUT OF OR IN CONNECTION
                WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN &gt; &gt; THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; ---------------------------------------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; ## minimalistic-assert &gt; License: ISC &gt; Repository:
                https://github.com/calvinmetcalf/minimalistic-assert.git
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; &gt; Copyright 2015 Calvin Metcalf &gt; &gt; &gt; &gt; Permission to use, copy, modify, and/or
                distribute this software for any purpose &gt; &gt; with or without fee is hereby granted, provided that
                the above copyright notice &gt; &gt; and this permission notice appear in all copies. &gt; &gt; &gt;
                &gt; THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH &gt; &gt; REGARD TO
                THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND &gt; &gt; FITNESS. IN NO EVENT
                SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT, &gt; &gt; INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY
                DAMAGES WHATSOEVER RESULTING FROM &gt; &gt; LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF
                CONTRACT, NEGLIGENCE &gt; &gt; OR OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
                &gt; &gt; PERFORMANCE OF THIS SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; ---------------------------------------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; ## normalize-path &gt; License: MIT &gt; By: Jon Schlinkert, Blaine Bublitz &gt; Repository:
                jonschlinkert/normalize-path
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; &gt; The MIT License (MIT) &gt; &gt; &gt; &gt; Copyright (c) 2014-2018, Jon Schlinkert. &gt; &gt;
                &gt; &gt; Permission is hereby granted, free of charge, to any person obtaining a copy &gt; &gt; of this
                software and associated documentation files (the "Software"), to deal &gt; &gt; in the Software without
                restriction, including without limitation the rights &gt; &gt; to use, copy, modify, merge, publish,
                distribute, sublicense, and/or sell &gt; &gt; copies of the Software, and to permit persons to whom the
                Software is &gt; &gt; furnished to do so, subject to the following conditions: &gt; &gt; &gt; &gt; The
                above copyright notice and this permission notice shall be included in &gt; &gt; all copies or
                substantial portions of the Software. &gt; &gt; &gt; &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
                WARRANTY OF ANY KIND, EXPRESS OR &gt; &gt; IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                MERCHANTABILITY, &gt; &gt; FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
                &gt; &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER &gt; &gt; LIABILITY,
                WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, &gt; &gt; OUT OF OR IN CONNECTION
                WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN &gt; &gt; THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; ---------------------------------------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; ## parse-ms &gt; License: MIT &gt; By: Sindre Sorhus &gt; Repository: sindresorhus/parse-ms
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; ---------------------------------------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; ## picomatch &gt; License: MIT &gt; By: Jon Schlinkert &gt; Repository: micromatch/picomatch
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; &gt; The MIT License (MIT) &gt; &gt; &gt; &gt; Copyright (c) 2017-present, Jon Schlinkert. &gt;
                &gt; &gt; &gt; Permission is hereby granted, free of charge, to any person obtaining a copy &gt; &gt; of
                this software and associated documentation files (the "Software"), to deal &gt; &gt; in the Software
                without restriction, including without limitation the rights &gt; &gt; to use, copy, modify, merge,
                publish, distribute, sublicense, and/or sell &gt; &gt; copies of the Software, and to permit persons to
                whom the Software is &gt; &gt; furnished to do so, subject to the following conditions: &gt; &gt; &gt;
                &gt; The above copyright notice and this permission notice shall be included in &gt; &gt; all copies or
                substantial portions of the Software. &gt; &gt; &gt; &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
                WARRANTY OF ANY KIND, EXPRESS OR &gt; &gt; IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                MERCHANTABILITY, &gt; &gt; FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
                &gt; &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER &gt; &gt; LIABILITY,
                WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, &gt; &gt; OUT OF OR IN CONNECTION
                WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN &gt; &gt; THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; ---------------------------------------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; ## pretty-bytes &gt; License: MIT &gt; By: Sindre Sorhus &gt; Repository: sindresorhus/pretty-bytes
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; ---------------------------------------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; ## pretty-ms &gt; License: MIT &gt; By: Sindre Sorhus &gt; Repository: sindresorhus/pretty-ms
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; ---------------------------------------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; ## readdirp &gt; License: MIT &gt; By: Thorsten Lorenz, Paul Miller &gt; Repository:
                git://github.com/paulmillr/readdirp.git
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; &gt; MIT License &gt; &gt; &gt; &gt; Copyright (c) 2012-2019 Thorsten Lorenz, Paul Miller
                (https://paulmillr.com) &gt; &gt; &gt; &gt; Permission is hereby granted, free of charge, to any person
                obtaining a copy &gt; &gt; of this software and associated documentation files (the "Software"), to deal
                &gt; &gt; in the Software without restriction, including without limitation the rights &gt; &gt; to use,
                copy, modify, merge, publish, distribute, sublicense, and/or sell &gt; &gt; copies of the Software, and
                to permit persons to whom the Software is &gt; &gt; furnished to do so, subject to the following
                conditions: &gt; &gt; &gt; &gt; The above copyright notice and this permission notice shall be included
                in all &gt; &gt; copies or substantial portions of the Software. &gt; &gt; &gt; &gt; THE SOFTWARE IS
                PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR &gt; &gt; IMPLIED, INCLUDING BUT NOT LIMITED
                TO THE WARRANTIES OF MERCHANTABILITY, &gt; &gt; FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                NO EVENT SHALL THE &gt; &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER &gt;
                &gt; LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, &gt; &gt; OUT OF OR
                IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE &gt; &gt; SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; ---------------------------------------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; ## require-relative &gt; License: MIT &gt; By: Valerio Proietti &gt; Repository:
                git://github.com/kamicane/require-relative.git
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; ---------------------------------------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; ## rollup-pluginutils &gt; License: MIT &gt; By: Rich Harris &gt; Repository:
                rollup/rollup-pluginutils
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; ---------------------------------------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; ## signal-exit &gt; License: ISC &gt; By: Ben Coe &gt; Repository:
                https://github.com/tapjs/signal-exit.git
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; &gt; The ISC License &gt; &gt; &gt; &gt; Copyright (c) 2015, Contributors &gt; &gt; &gt; &gt;
                Permission to use, copy, modify, and/or distribute this software &gt; &gt; for any purpose with or
                without fee is hereby granted, provided &gt; &gt; that the above copyright notice and this permission
                notice &gt; &gt; appear in all copies. &gt; &gt; &gt; &gt; THE SOFTWARE IS PROVIDED "AS IS" AND THE
                AUTHOR DISCLAIMS ALL WARRANTIES &gt; &gt; WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES
                &gt; &gt; OF MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE &gt; &gt; LIABLE FOR ANY
                SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES &gt; &gt; OR ANY DAMAGES WHATSOEVER RESULTING FROM
                LOSS OF USE, DATA OR PROFITS, &gt; &gt; WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS
                ACTION, &gt; &gt; ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; ---------------------------------------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; ## sourcemap-codec &gt; License: MIT &gt; By: Rich Harris &gt; Repository:
                https://github.com/Rich-Harris/sourcemap-codec
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; &gt; The MIT License &gt; &gt; &gt; &gt; Copyright (c) 2015 Rich Harris &gt; &gt; &gt; &gt;
                Permission is hereby granted, free of charge, to any person obtaining a copy &gt; &gt; of this software
                and associated documentation files (the "Software"), to deal &gt; &gt; in the Software without
                restriction, including without limitation the rights &gt; &gt; to use, copy, modify, merge, publish,
                distribute, sublicense, and/or sell &gt; &gt; copies of the Software, and to permit persons to whom the
                Software is &gt; &gt; furnished to do so, subject to the following conditions: &gt; &gt; &gt; &gt; The
                above copyright notice and this permission notice shall be included in &gt; &gt; all copies or
                substantial portions of the Software. &gt; &gt; &gt; &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
                WARRANTY OF ANY KIND, EXPRESS OR &gt; &gt; IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                MERCHANTABILITY, &gt; &gt; FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
                &gt; &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER &gt; &gt; LIABILITY,
                WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, &gt; &gt; OUT OF OR IN CONNECTION
                WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN &gt; &gt; THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; ---------------------------------------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; ## time-zone &gt; License: MIT &gt; By: Sindre Sorhus &gt; Repository: sindresorhus/time-zone
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; ---------------------------------------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; ## to-regex-range &gt; License: MIT &gt; By: Jon Schlinkert, Rouven Weßling &gt; Repository:
                micromatch/to-regex-range
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; &gt; The MIT License (MIT) &gt; &gt; &gt; &gt; Copyright (c) 2015-present, Jon Schlinkert. &gt;
                &gt; &gt; &gt; Permission is hereby granted, free of charge, to any person obtaining a copy &gt; &gt; of
                this software and associated documentation files (the "Software"), to deal &gt; &gt; in the Software
                without restriction, including without limitation the rights &gt; &gt; to use, copy, modify, merge,
                publish, distribute, sublicense, and/or sell &gt; &gt; copies of the Software, and to permit persons to
                whom the Software is &gt; &gt; furnished to do so, subject to the following conditions: &gt; &gt; &gt;
                &gt; The above copyright notice and this permission notice shall be included in &gt; &gt; all copies or
                substantial portions of the Software. &gt; &gt; &gt; &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
                WARRANTY OF ANY KIND, EXPRESS OR &gt; &gt; IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                MERCHANTABILITY, &gt; &gt; FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
                &gt; &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER &gt; &gt; LIABILITY,
                WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, &gt; &gt; OUT OF OR IN CONNECTION
                WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN &gt; &gt; THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; ---------------------------------------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; ## yargs-parser &gt; License: ISC &gt; By: Ben Coe &gt; Repository:
                https://github.com/yargs/yargs-parser.git
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; &gt; Copyright (c) 2016, Contributors &gt; &gt; &gt; &gt; Permission to use, copy, modify, and/or
                distribute this software &gt; &gt; for any purpose with or without fee is hereby granted, provided &gt;
                &gt; that the above copyright notice and this permission notice &gt; &gt; appear in all copies. &gt;
                &gt; &gt; &gt; THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES &gt; &gt; WITH
                REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES &gt; &gt; OF MERCHANTABILITY AND FITNESS. IN NO
                EVENT SHALL THE AUTHOR BE &gt; &gt; LIABLE FOR ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES
                &gt; &gt; OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, &gt; &gt; WHETHER IN AN
                ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, &gt; &gt; ARISING OUT OF OR IN CONNECTION WITH
                THE USE OR PERFORMANCE OF THIS SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `semver`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: ISC</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; The ISC License</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Copyright (c) Isaac Z. Schlueter and Contributors</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission to use, copy, modify, and/or distribute this software for any &gt; purpose with or
                without fee is hereby granted, provided that the above &gt; copyright notice and this permission notice
                appear in all copies.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES &gt; WITH REGARD TO THIS
                SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF &gt; MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE
                AUTHOR BE LIABLE FOR &gt; ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES &gt;
                WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN &gt; ACTION OF CONTRACT,
                NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR &gt; IN CONNECTION WITH THE USE OR PERFORMANCE OF
                THIS SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `sisteransi`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: [Terkel Gjervig](https://terkel.com)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; MIT License</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Copyright (c) 2018 Terkel Gjervig Nielsen</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a copy &gt; of this software
                and associated documentation files (the "Software"), to deal &gt; in the Software without restriction,
                including without limitation the rights &gt; to use, copy, modify, merge, publish, distribute,
                sublicense, and/or sell &gt; copies of the Software, and to permit persons to whom the Software is &gt;
                furnished to do so, subject to the following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in all &gt; copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR &gt; IMPLIED, INCLUDING
                BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, &gt; FITNESS FOR A PARTICULAR PURPOSE AND
                NONINFRINGEMENT. IN NO EVENT SHALL THE &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                DAMAGES OR OTHER &gt; LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, &gt;
                OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE &gt; SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `sizzle`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                Author: [JS Foundation and other contributors](https://github.com/jquery/sizzle/blob/2.3.6/AUTHORS.txt)
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Homepage: https://sizzlejs.com</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Copyright JS Foundation and other contributors, https://js.foundation/
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; This software consists of voluntary contributions made by many &gt; individuals. For exact
                contribution history, see the revision history &gt; available at https://github.com/jquery/sizzle
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The following license applies to all parts of this software except as &gt; documented below:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; ====</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining &gt; a copy of this software
                and associated documentation files (the &gt; "Software"), to deal in the Software without restriction,
                including &gt; without limitation the rights to use, copy, modify, merge, publish, &gt; distribute,
                sublicense, and/or sell copies of the Software, and to &gt; permit persons to whom the Software is
                furnished to do so, subject to &gt; the following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be &gt; included in all copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, &gt; EXPRESS OR IMPLIED, INCLUDING
                BUT NOT LIMITED TO THE WARRANTIES OF &gt; MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND &gt;
                NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE &gt; LIABLE FOR ANY CLAIM,
                DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION &gt; OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT
                OF OR IN CONNECTION &gt; WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; ====</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; All files located in the node_modules and external directories are &gt; externally maintained
                libraries used by this software which have their &gt; own licenses; we recommend you read them, as their
                terms may differ from &gt; the terms above.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `source-map`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: BSD-3-Clause</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: Nick Fitzgerald &lt;nfitzgerald@mozilla.com&gt;</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                Contributors: Tobias Koppers &lt;tobias.koppers@googlemail.com&gt;, Duncan Beevers
                &lt;duncan@dweebd.com&gt;, Stephen Crane &lt;scrane@mozilla.com&gt;, Ryan Seddon
                &lt;seddon.ryan@gmail.com&gt;, Miles Elam &lt;miles.elam@deem.com&gt;, Mihai Bazon
                &lt;mihai.bazon@gmail.com&gt;, Michael Ficarra &lt;github.public.email@michael.ficarra.me&gt;, Todd
                Wolfson &lt;todd@twolfson.com&gt;, Alexander Solovyov &lt;alexander@solovyov.net&gt;, Felix Gnass
                &lt;fgnass@gmail.com&gt;, Conrad Irwin &lt;conrad.irwin@gmail.com&gt;, usrbincc
                &lt;usrbincc@yahoo.com&gt;, David Glasser &lt;glasser@davidglasser.net&gt;, Chase Douglas
                &lt;chase@newrelic.com&gt;, Evan Wallace &lt;evan.exe@gmail.com&gt;, Heather Arthur
                &lt;fayearthur@gmail.com&gt;, Hugh Kennedy &lt;hughskennedy@gmail.com&gt;, David Glasser
                &lt;glasser@davidglasser.net&gt;, Simon Lydell &lt;simon.lydell@gmail.com&gt;, Jmeas Smith
                &lt;jellyes2@gmail.com&gt;, Michael Z Goddard &lt;mzgoddard@gmail.com&gt;, azu
                &lt;azu@users.noreply.github.com&gt;, John Gozde &lt;john@gozde.ca&gt;, Adam Kirkton
                &lt;akirkton@truefitinnovation.com&gt;, Chris Montgomery &lt;christopher.montgomery@dowjones.com&gt;, J.
                Ryan Stinnett &lt;jryans@gmail.com&gt;, Jack Herrington &lt;jherrington@walmartlabs.com&gt;, Chris
                Truter &lt;jeffpalentine@gmail.com&gt;, Daniel Espeset &lt;daniel@danielespeset.com&gt;, Jamie Wong
                &lt;jamie.lf.wong@gmail.com&gt;, Eddy Bruël &lt;ejpbruel@mozilla.com&gt;, Hawken Rives
                &lt;hawkrives@gmail.com&gt;, Gilad Peleg &lt;giladp007@gmail.com&gt;, djchie
                &lt;djchie.dev@gmail.com&gt;, Gary Ye &lt;garysye@gmail.com&gt;, Nicolas Lalevée
                &lt;nicolas.lalevee@hibnet.org&gt;
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Homepage: https://github.com/mozilla/source-map</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Copyright (c) 2009-2011, Mozilla Foundation and contributors &gt; All rights reserved.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Redistribution and use in source and binary forms, with or without &gt; modification, are permitted
                provided that the following conditions are met:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; * Redistributions of source code must retain the above copyright notice, this &gt; list of
                conditions and the following disclaimer.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; * Redistributions in binary form must reproduce the above copyright notice, &gt; this list of
                conditions and the following disclaimer in the documentation &gt; and/or other materials provided with
                the distribution.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; * Neither the names of the Mozilla Foundation nor the names of project &gt; contributors may be
                used to endorse or promote products derived from this &gt; software without specific prior written
                permission.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND &gt; ANY EXPRESS OR
                IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED &gt; WARRANTIES OF MERCHANTABILITY AND
                FITNESS FOR A PARTICULAR PURPOSE ARE &gt; DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR
                CONTRIBUTORS BE LIABLE &gt; FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
                &gt; DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR &gt; SERVICES; LOSS OF
                USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER &gt; CAUSED AND ON ANY THEORY OF LIABILITY,
                WHETHER IN CONTRACT, STRICT LIABILITY, &gt; OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY
                WAY OUT OF THE USE &gt; OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `source-map-support`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; The MIT License (MIT)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Copyright (c) 2014 Evan Wallace</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a copy &gt; of this software
                and associated documentation files (the "Software"), to deal &gt; in the Software without restriction,
                including without limitation the rights &gt; to use, copy, modify, merge, publish, distribute,
                sublicense, and/or sell &gt; copies of the Software, and to permit persons to whom the Software is &gt;
                furnished to do so, subject to the following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in all &gt; copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR &gt; IMPLIED, INCLUDING
                BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, &gt; FITNESS FOR A PARTICULAR PURPOSE AND
                NONINFRINGEMENT. IN NO EVENT SHALL THE &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                DAMAGES OR OTHER &gt; LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, &gt;
                OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE &gt; SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `sourcemap-codec`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: Rich Harris</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Homepage: https://github.com/Rich-Harris/sourcemap-codec</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; The MIT License</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Copyright (c) 2015 Rich Harris</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a copy &gt; of this software
                and associated documentation files (the "Software"), to deal &gt; in the Software without restriction,
                including without limitation the rights &gt; to use, copy, modify, merge, publish, distribute,
                sublicense, and/or sell &gt; copies of the Software, and to permit persons to whom the Software is &gt;
                furnished to do so, subject to the following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in &gt; all copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR &gt; IMPLIED, INCLUDING
                BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, &gt; FITNESS FOR A PARTICULAR PURPOSE AND
                NONINFRINGEMENT. IN NO EVENT SHALL THE &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                DAMAGES OR OTHER &gt; LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, &gt;
                OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN &gt; THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `terser`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: BSD-2-Clause</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                Author: Mihai Bazon &lt;mihai.bazon@gmail.com&gt; (http://lisperator.net/)
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Homepage: https://terser.org</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Terser is released under the BSD license:</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Copyright 2012-2018 (c) Mihai Bazon &lt;mihai.bazon@gmail.com&gt;</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Redistribution and use in source and binary forms, with or without &gt; modification, are permitted
                provided that the following conditions &gt; are met:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; * Redistributions of source code must retain the above &gt; copyright notice, this list of
                conditions and the following &gt; disclaimer.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; * Redistributions in binary form must reproduce the above &gt; copyright notice, this list of
                conditions and the following &gt; disclaimer in the documentation and/or other materials &gt; provided
                with the distribution.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDER “AS IS” AND ANY &gt; EXPRESS OR IMPLIED
                WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE &gt; IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
                FOR A PARTICULAR &gt; PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER BE &gt; LIABLE FOR
                ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, &gt; OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
                LIMITED TO, &gt; PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR &gt; PROFITS; OR
                BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY &gt; THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
                LIABILITY, OR &gt; TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF &gt; THE USE OF
                THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF &gt; SUCH DAMAGE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `tr46`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: Sebastian Mayr &lt;npm@smayr.name&gt;</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Contributors: Timothy Gu &lt;timothygu99@gmail.com&gt;</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; The MIT License (MIT)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Copyright (c) 2016 Sebastian Mayr</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a copy &gt; of this software
                and associated documentation files (the "Software"), to deal &gt; in the Software without restriction,
                including without limitation the rights &gt; to use, copy, modify, merge, publish, distribute,
                sublicense, and/or sell &gt; copies of the Software, and to permit persons to whom the Software is &gt;
                furnished to do so, subject to the following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in all &gt; copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR &gt; IMPLIED, INCLUDING
                BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, &gt; FITNESS FOR A PARTICULAR PURPOSE AND
                NONINFRINGEMENT. IN NO EVENT SHALL THE &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                DAMAGES OR OTHER &gt; LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, &gt;
                OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE &gt; SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `typescript`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: Apache-2.0</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: Microsoft Corp.</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Homepage: https://www.typescriptlang.org/</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Apache License</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Version 2.0, January 2004</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; http://www.apache.org/licenses/</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; TERMS AND CONDITIONS FOR USE, REPRODUCTION, AND DISTRIBUTION</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; 1. Definitions.</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; "License" shall mean the terms and conditions for use, reproduction, and distribution as defined by
                Sections 1 through 9 of this document.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; "Licensor" shall mean the copyright owner or entity authorized by the copyright owner that is
                granting the License.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; "Legal Entity" shall mean the union of the acting entity and all other entities that control, are
                controlled by, or are under common control with that entity. For the purposes of this definition,
                "control" means (i) the power, direct or indirect, to cause the direction or management of such entity,
                whether by contract or otherwise, or (ii) ownership of fifty percent (50%) or more of the outstanding
                shares, or (iii) beneficial ownership of such entity.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; "You" (or "Your") shall mean an individual or Legal Entity exercising permissions granted by this
                License.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; "Source" form shall mean the preferred form for making modifications, including but not limited to
                software source code, documentation source, and configuration files.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; "Object" form shall mean any form resulting from mechanical transformation or translation of a
                Source form, including but not limited to compiled object code, generated documentation, and conversions
                to other media types.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; "Work" shall mean the work of authorship, whether in Source or Object form, made available under
                the License, as indicated by a copyright notice that is included in or attached to the work (an example
                is provided in the Appendix below).
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; "Derivative Works" shall mean any work, whether in Source or Object form, that is based on (or
                derived from) the Work and for which the editorial revisions, annotations, elaborations, or other
                modifications represent, as a whole, an original work of authorship. For the purposes of this License,
                Derivative Works shall not include works that remain separable from, or merely link (or bind by name) to
                the interfaces of, the Work and Derivative Works thereof.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; "Contribution" shall mean any work of authorship, including the original version of the Work and
                any modifications or additions to that Work or Derivative Works thereof, that is intentionally submitted
                to Licensor for inclusion in the Work by the copyright owner or by an individual or Legal Entity
                authorized to submit on behalf of the copyright owner. For the purposes of this definition, "submitted"
                means any form of electronic, verbal, or written communication sent to the Licensor or its
                representatives, including but not limited to communication on electronic mailing lists, source code
                control systems, and issue tracking systems that are managed by, or on behalf of, the Licensor for the
                purpose of discussing and improving the Work, but excluding communication that is conspicuously marked
                or otherwise designated in writing by the copyright owner as "Not a Contribution."
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; "Contributor" shall mean Licensor and any individual or Legal Entity on behalf of whom a
                Contribution has been received by Licensor and subsequently incorporated within the Work.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; 2. Grant of Copyright License. Subject to the terms and conditions of this License, each
                Contributor hereby grants to You a perpetual, worldwide, non-exclusive, no-charge, royalty-free,
                irrevocable copyright license to reproduce, prepare Derivative Works of, publicly display, publicly
                perform, sublicense, and distribute the Work and such Derivative Works in Source or Object form.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; 3. Grant of Patent License. Subject to the terms and conditions of this License, each Contributor
                hereby grants to You a perpetual, worldwide, non-exclusive, no-charge, royalty-free, irrevocable (except
                as stated in this section) patent license to make, have made, use, offer to sell, sell, import, and
                otherwise transfer the Work, where such license applies only to those patent claims licensable by such
                Contributor that are necessarily infringed by their Contribution(s) alone or by combination of their
                Contribution(s) with the Work to which such Contribution(s) was submitted. If You institute patent
                litigation against any entity (including a cross-claim or counterclaim in a lawsuit) alleging that the
                Work or a Contribution incorporated within the Work constitutes direct or contributory patent
                infringement, then any patent licenses granted to You under this License for that Work shall terminate
                as of the date such litigation is filed.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; 4. Redistribution. You may reproduce and distribute copies of the Work or Derivative Works thereof
                in any medium, with or without modifications, and in Source or Object form, provided that You meet the
                following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; You must give any other recipients of the Work or Derivative Works a copy of this License; and
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; You must cause any modified files to carry prominent notices stating that You changed the files;
                and
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; You must retain, in the Source form of any Derivative Works that You distribute, all copyright,
                patent, trademark, and attribution notices from the Source form of the Work, excluding those notices
                that do not pertain to any part of the Derivative Works; and
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; If the Work includes a "NOTICE" text file as part of its distribution, then any Derivative Works
                that You distribute must include a readable copy of the attribution notices contained within such NOTICE
                file, excluding those notices that do not pertain to any part of the Derivative Works, in at least one
                of the following places: within a NOTICE text file distributed as part of the Derivative Works; within
                the Source form or documentation, if provided along with the Derivative Works; or, within a display
                generated by the Derivative Works, if and wherever such third-party notices normally appear. The
                contents of the NOTICE file are for informational purposes only and do not modify the License. You may
                add Your own attribution notices within Derivative Works that You distribute, alongside or as an
                addendum to the NOTICE text from the Work, provided that such additional attribution notices cannot be
                construed as modifying the License. You may add Your own copyright statement to Your modifications and
                may provide additional or different license terms and conditions for use, reproduction, or distribution
                of Your modifications, or for any such Derivative Works as a whole, provided Your use, reproduction, and
                distribution of the Work otherwise complies with the conditions stated in this License.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; 5. Submission of Contributions. Unless You explicitly state otherwise, any Contribution
                intentionally submitted for inclusion in the Work by You to the Licensor shall be under the terms and
                conditions of this License, without any additional terms or conditions. Notwithstanding the above,
                nothing herein shall supersede or modify the terms of any separate license agreement you may have
                executed with Licensor regarding such Contributions.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; 6. Trademarks. This License does not grant permission to use the trade names, trademarks, service
                marks, or product names of the Licensor, except as required for reasonable and customary use in
                describing the origin of the Work and reproducing the content of the NOTICE file.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; 7. Disclaimer of Warranty. Unless required by applicable law or agreed to in writing, Licensor
                provides the Work (and each Contributor provides its Contributions) on an "AS IS" BASIS, WITHOUT
                WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied, including, without limitation, any
                warranties or conditions of TITLE, NON-INFRINGEMENT, MERCHANTABILITY, or FITNESS FOR A PARTICULAR
                PURPOSE. You are solely responsible for determining the appropriateness of using or redistributing the
                Work and assume any risks associated with Your exercise of permissions under this License.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; 8. Limitation of Liability. In no event and under no legal theory, whether in tort (including
                negligence), contract, or otherwise, unless required by applicable law (such as deliberate and grossly
                negligent acts) or agreed to in writing, shall any Contributor be liable to You for damages, including
                any direct, indirect, special, incidental, or consequential damages of any character arising as a result
                of this License or out of the use or inability to use the Work (including but not limited to damages for
                loss of goodwill, work stoppage, computer failure or malfunction, or any and all other commercial
                damages or losses), even if such Contributor has been advised of the possibility of such damages.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; 9. Accepting Warranty or Additional Liability. While redistributing the Work or Derivative Works
                thereof, You may choose to offer, and charge a fee for, acceptance of support, warranty, indemnity, or
                other liability obligations and/or rights consistent with this License. However, in accepting such
                obligations, You may act only on Your own behalf and on Your sole responsibility, not on behalf of any
                other Contributor, and only if You agree to indemnify, defend, and hold each Contributor harmless for
                any liability incurred by, or claims asserted against, such Contributor by reason of your accepting any
                such warranty or additional liability.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; END OF TERMS AND CONDITIONS</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `webidl-conversions`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: BSD-2-Clause</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: Domenic Denicola &lt;d@domenic.me&gt; (https://domenic.me/)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; # The BSD 2-Clause License</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Copyright (c) 2014, Domenic Denicola &gt; All rights reserved.</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Redistribution and use in source and binary forms, with or without modification, are permitted
                provided that the following conditions are met:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; 1. Redistributions of source code must retain the above copyright notice, this list of conditions
                and the following disclaimer.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; 2. Redistributions in binary form must reproduce the above copyright notice, this list of
                conditions and the following disclaimer in the documentation and/or other materials provided with the
                distribution.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR
                IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
                FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
                LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
                BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR
                BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
                LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
                SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `whatwg-url`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: Sebastian Mayr &lt;github@smayr.name&gt;</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; The MIT License (MIT)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Copyright (c) 2015–2016 Sebastian Mayr</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a copy &gt; of this software
                and associated documentation files (the "Software"), to deal &gt; in the Software without restriction,
                including without limitation the rights &gt; to use, copy, modify, merge, publish, distribute,
                sublicense, and/or sell &gt; copies of the Software, and to permit persons to whom the Software is &gt;
                furnished to do so, subject to the following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in &gt; all copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR &gt; IMPLIED, INCLUDING
                BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, &gt; FITNESS FOR A PARTICULAR PURPOSE AND
                NONINFRINGEMENT. IN NO EVENT SHALL THE &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                DAMAGES OR OTHER &gt; LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, &gt;
                OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN &gt; THE SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `wrappy`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: ISC</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: Isaac Z. Schlueter &lt;i@izs.me&gt; (http://blog.izs.me/)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Homepage: https://github.com/npm/wrappy</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; The ISC License</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Copyright (c) Isaac Z. Schlueter and Contributors</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission to use, copy, modify, and/or distribute this software for any &gt; purpose with or
                without fee is hereby granted, provided that the above &gt; copyright notice and this permission notice
                appear in all copies.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES &gt; WITH REGARD TO THIS
                SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF &gt; MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE
                AUTHOR BE LIABLE FOR &gt; ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES &gt;
                WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN &gt; ACTION OF CONTRACT,
                NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR &gt; IN CONNECTION WITH THE USE OR PERFORMANCE OF
                THIS SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `ws`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: MIT</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: Einar Otto Stangvik &lt;einaros@gmail.com&gt; (http://2x.io)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Homepage: https://github.com/websockets/ws</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; The MIT License (MIT)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Copyright (c) 2011 Einar Otto Stangvik &lt;einaros@gmail.com&gt;</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission is hereby granted, free of charge, to any person obtaining a copy &gt; of this software
                and associated documentation files (the "Software"), to deal &gt; in the Software without restriction,
                including without limitation the rights &gt; to use, copy, modify, merge, publish, distribute,
                sublicense, and/or sell &gt; copies of the Software, and to permit persons to whom the Software is &gt;
                furnished to do so, subject to the following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; The above copyright notice and this permission notice shall be included in all &gt; copies or
                substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR &gt; IMPLIED, INCLUDING
                BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, &gt; FITNESS FOR A PARTICULAR PURPOSE AND
                NONINFRINGEMENT. IN NO EVENT SHALL THE &gt; AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                DAMAGES OR OTHER &gt; LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, &gt;
                OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE &gt; SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">## `yallist`</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">License: ISC</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Author: Isaac Z. Schlueter &lt;i@izs.me&gt; (http://blog.izs.me/)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; The ISC License</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">&gt; Copyright (c) Isaac Z. Schlueter and Contributors</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; Permission to use, copy, modify, and/or distribute this software for any &gt; purpose with or
                without fee is hereby granted, provided that the above &gt; copyright notice and this permission notice
                appear in all copies.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                &gt; THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES &gt; WITH REGARD TO THIS
                SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF &gt; MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE
                AUTHOR BE LIABLE FOR &gt; ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES &gt;
                WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN &gt; ACTION OF CONTRACT,
                NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR &gt; IN CONNECTION WITH THE USE OR PERFORMANCE OF
                THIS SOFTWARE.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">--------</span>
              <br />
            </p>
            <p style={{ marginTop: '0.0pt', marginBottom: '8.0pt', whiteSpace: 'pre-wrap' }}></p>
            <p
              className="licTypeName"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '8.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licTypeName">MIT</span>
            </p>
            <table>
              <tbody>
                <tr>
                  <td
                    style={{
                      backgroundColor: '#c5d9f1',
                      borderTop: '0.25px solid',
                      borderBottom: '0.25px solid',
                      borderLeft: '0.25px solid',
                      borderRight: '0.25px solid',
                    }}
                  >
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>Product</span>
                    </p>
                  </td>
                  <td
                    style={{
                      backgroundColor: '#c5d9f1',
                      borderTop: '0.25px solid',
                      borderBottom: '0.25px solid',
                      borderLeft: '0.25px solid',
                      borderRight: '0.25px solid',
                    }}
                  >
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Component
                      </span>
                    </p>
                  </td>
                  <td
                    style={{
                      backgroundColor: '#c5d9f1',
                      borderTop: '0.25px solid',
                      borderBottom: '0.25px solid',
                      borderLeft: '0.25px solid',
                      borderRight: '0.25px solid',
                    }}
                  >
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>Version</span>
                    </p>
                  </td>
                  <td
                    style={{
                      backgroundColor: '#c5d9f1',
                      borderTop: '0.25px solid',
                      borderBottom: '0.25px solid',
                      borderLeft: '0.25px solid',
                      borderRight: '0.25px solid',
                    }}
                  >
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Copyright notice
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Scheduler
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        scheduler
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>0.20.2</span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'left', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Copyright (C) Facebook, Inc. and its affiliates
                      </span>
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <br />
              <span className="licText">MIT License</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">Copyright (c)</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                Permission is hereby granted, free of charge, to any person obtaining a copy of this software and
                associated documentation files (the "Software"), to deal in the Software without restriction, including
                without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
                copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the
                following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                The above copyright notice and this permission notice (including the next paragraph) shall be included
                in all copies or substantial portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT
                LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
                WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
                SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
              </span>
              <br />
            </p>
            <p style={{ marginTop: '0.0pt', marginBottom: '8.0pt', whiteSpace: 'pre-wrap' }}></p>
            <p
              className="licTypeName"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '8.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licTypeName">MIT</span>
            </p>
            <table>
              <tbody>
                <tr>
                  <td
                    style={{
                      backgroundColor: '#c5d9f1',
                      borderTop: '0.25px solid',
                      borderBottom: '0.25px solid',
                      borderLeft: '0.25px solid',
                      borderRight: '0.25px solid',
                    }}
                  >
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>Product</span>
                    </p>
                  </td>
                  <td
                    style={{
                      backgroundColor: '#c5d9f1',
                      borderTop: '0.25px solid',
                      borderBottom: '0.25px solid',
                      borderLeft: '0.25px solid',
                      borderRight: '0.25px solid',
                    }}
                  >
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Component
                      </span>
                    </p>
                  </td>
                  <td
                    style={{
                      backgroundColor: '#c5d9f1',
                      borderTop: '0.25px solid',
                      borderBottom: '0.25px solid',
                      borderLeft: '0.25px solid',
                      borderRight: '0.25px solid',
                    }}
                  >
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>Version</span>
                    </p>
                  </td>
                  <td
                    style={{
                      backgroundColor: '#c5d9f1',
                      borderTop: '0.25px solid',
                      borderBottom: '0.25px solid',
                      borderLeft: '0.25px solid',
                      borderRight: '0.25px solid',
                    }}
                  >
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Copyright notice
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>History</span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>history</span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>5.3.0</span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'left', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Copyright (C) React Training 2016-2020, Copyright (C) Remix Software 2020-2021
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        React Router Dom
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        react-router-dom
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>6.3.0</span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'left', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Copyright (C) React Training 2015-2019, Copyright (C) Remix Software 2020-2021
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        React Router
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        react-router
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>6.3.0</span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'left', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Copyright (C) React Training 2015-2019, Copyright (C) Remix Software 2020-2021
                      </span>
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <br />
              <span className="licText">MIT License</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                Copyright (c) React Training 2015-2019 Copyright (c) Remix Software 2020-2021
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                Permission is hereby granted, free of charge, to any person obtaining a copy of this software and
                associated documentation files (the "Software"), to deal in the Software without restriction, including
                without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
                copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the
                following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                The above copyright notice and this permission notice shall be included in all copies or substantial
                portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT
                LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
                WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
                SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
              </span>
              <br />
            </p>
            <p style={{ marginTop: '0.0pt', marginBottom: '8.0pt', whiteSpace: 'pre-wrap' }}></p>
            <p
              className="licTypeName"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '8.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licTypeName">MIT</span>
            </p>
            <table>
              <tbody>
                <tr>
                  <td
                    style={{
                      backgroundColor: '#c5d9f1',
                      borderTop: '0.25px solid',
                      borderBottom: '0.25px solid',
                      borderLeft: '0.25px solid',
                      borderRight: '0.25px solid',
                    }}
                  >
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>Product</span>
                    </p>
                  </td>
                  <td
                    style={{
                      backgroundColor: '#c5d9f1',
                      borderTop: '0.25px solid',
                      borderBottom: '0.25px solid',
                      borderLeft: '0.25px solid',
                      borderRight: '0.25px solid',
                    }}
                  >
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Component
                      </span>
                    </p>
                  </td>
                  <td
                    style={{
                      backgroundColor: '#c5d9f1',
                      borderTop: '0.25px solid',
                      borderBottom: '0.25px solid',
                      borderLeft: '0.25px solid',
                      borderRight: '0.25px solid',
                    }}
                  >
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>Version</span>
                    </p>
                  </td>
                  <td
                    style={{
                      backgroundColor: '#c5d9f1',
                      borderTop: '0.25px solid',
                      borderBottom: '0.25px solid',
                      borderLeft: '0.25px solid',
                      borderRight: '0.25px solid',
                    }}
                  >
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Copyright notice
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Html Escaper
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        html-escaper
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>2.0.2</span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'left', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Copyright (c) 2017-present by Andrea Giammarchi
                      </span>
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <br />
              <span className="licText">Copyright (C) 2017-present by Andrea Giammarchi - @WebReflection</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                Permission is hereby granted, free of charge, to any person obtaining a copy of this software and
                associated documentation files (the "Software"), to deal in the Software without restriction, including
                without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
                copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the
                following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                The above copyright notice and this permission notice shall be included in all copies or substantial
                portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT
                LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
                WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
                SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
              </span>
              <br />
            </p>
            <p style={{ marginTop: '0.0pt', marginBottom: '8.0pt', whiteSpace: 'pre-wrap' }}></p>
            <p
              className="licTypeName"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '8.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licTypeName">MIT</span>
            </p>
            <table>
              <tbody>
                <tr>
                  <td
                    style={{
                      backgroundColor: '#c5d9f1',
                      borderTop: '0.25px solid',
                      borderBottom: '0.25px solid',
                      borderLeft: '0.25px solid',
                      borderRight: '0.25px solid',
                    }}
                  >
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>Product</span>
                    </p>
                  </td>
                  <td
                    style={{
                      backgroundColor: '#c5d9f1',
                      borderTop: '0.25px solid',
                      borderBottom: '0.25px solid',
                      borderLeft: '0.25px solid',
                      borderRight: '0.25px solid',
                    }}
                  >
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Component
                      </span>
                    </p>
                  </td>
                  <td
                    style={{
                      backgroundColor: '#c5d9f1',
                      borderTop: '0.25px solid',
                      borderBottom: '0.25px solid',
                      borderLeft: '0.25px solid',
                      borderRight: '0.25px solid',
                    }}
                  >
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>Version</span>
                    </p>
                  </td>
                  <td
                    style={{
                      backgroundColor: '#c5d9f1',
                      borderTop: '0.25px solid',
                      borderBottom: '0.25px solid',
                      borderLeft: '0.25px solid',
                      borderRight: '0.25px solid',
                    }}
                  >
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Copyright notice
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Combined Stream
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        combined-stream
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>1.0.8</span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'left', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Copyright (C) 2011 Debuggable Limited &lt;felix@debuggable.com&gt;
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Delayed Stream
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        delayed-stream
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>1.0.0</span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'left', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Copyright (C) 2011 Debuggable Limited &lt;felix@debuggable.com&gt;
                      </span>
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <br />
              <span className="licText">Copyright (c) 2011 Debuggable Limited &lt;felix@debuggable.com&gt;</span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                Permission is hereby granted, free of charge, to any person obtaining a copy of this software and
                associated documentation files (the "Software"), to deal in the Software without restriction, including
                without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
                copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the
                following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                The above copyright notice and this permission notice shall be included in all copies or substantial
                portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT
                LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
                WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
                SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
              </span>
              <br />
            </p>
            <p style={{ marginTop: '0.0pt', marginBottom: '8.0pt', whiteSpace: 'pre-wrap' }}></p>
            <p
              className="licTypeName"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '8.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licTypeName">MIT</span>
            </p>
            <table>
              <tbody>
                <tr>
                  <td
                    style={{
                      backgroundColor: '#c5d9f1',
                      borderTop: '0.25px solid',
                      borderBottom: '0.25px solid',
                      borderLeft: '0.25px solid',
                      borderRight: '0.25px solid',
                    }}
                  >
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>Product</span>
                    </p>
                  </td>
                  <td
                    style={{
                      backgroundColor: '#c5d9f1',
                      borderTop: '0.25px solid',
                      borderBottom: '0.25px solid',
                      borderLeft: '0.25px solid',
                      borderRight: '0.25px solid',
                    }}
                  >
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Component
                      </span>
                    </p>
                  </td>
                  <td
                    style={{
                      backgroundColor: '#c5d9f1',
                      borderTop: '0.25px solid',
                      borderBottom: '0.25px solid',
                      borderLeft: '0.25px solid',
                      borderRight: '0.25px solid',
                    }}
                  >
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>Version</span>
                    </p>
                  </td>
                  <td
                    style={{
                      backgroundColor: '#c5d9f1',
                      borderTop: '0.25px solid',
                      borderBottom: '0.25px solid',
                      borderLeft: '0.25px solid',
                      borderRight: '0.25px solid',
                    }}
                  >
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Copyright notice
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Form Data
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        form-data
                      </span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>4.0.0</span>
                    </p>
                  </td>
                  <td>
                    <p style={{ textAlign: 'left', whiteSpace: 'pre-wrap' }}>
                      <span style={{ fontFamily: '"Arial"', fontSize: '11.0pt', whiteSpace: 'pre-wrap' }}>
                        Copyright (C) 2012 Felix Geisendorfer (felix@debuggable.com) and contributors
                      </span>
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <br />
              <span className="licText">
                Copyright (c) 2012 Felix Geisendörfer (felix@debuggable.com) and contributors
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                Permission is hereby granted, free of charge, to any person obtaining a copy of this software and
                associated documentation files (the "Software"), to deal in the Software without restriction, including
                without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
                copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the
                following conditions:
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                The above copyright notice and this permission notice shall be included in all copies or substantial
                portions of the Software.
              </span>
              <br />
            </p>
            <p
              className="licText"
              style={{ textAlign: 'left', marginTop: '0.0pt', marginBottom: '0.0pt', whiteSpace: 'pre-wrap' }}
            >
              <span className="licText">
                THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT
                LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
                WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
                SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
              </span>
              <br />
            </p>
            <p style={{ marginTop: '0.0pt', marginBottom: '8.0pt', whiteSpace: 'pre-wrap' }}></p>
          </div>
        </GroupuiGridCol>
      </GroupuiGridRow>

      <GroupuiGridRow type="fixed">
        <GroupuiGridCol s="0" m="1" l="1" xl="1" xxl="1" />
        <GroupuiGridCol s="12" m="10" l="10" xl="10" xxl="10">
          <Footer />
        </GroupuiGridCol>
        <GroupuiGridCol s="0" m="1" l="1" xl="1" xxl="1" />
      </GroupuiGridRow>
    </div>
  );
};

export default License;
